/**
 * コンテンツ登録
 */
import React from 'react';
import PropTypes from 'prop-types';
import DateFnsUtils from '@date-io/date-fns';
import zhCNLocale from 'date-fns/locale/zh-CN';
import jaLocale from 'date-fns/locale/ja';
import enLocale from 'date-fns/locale/en-US';
import { MuiPickersUtilsProvider, DateTimePicker } from 'material-ui-pickers';
import { withStyles } from '@material-ui/core/styles';
import {
  Grid,
  InputLabel,
  InputBase,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Button,
  Checkbox,
  Input,
  Select,
  MenuItem,
  GridList,
  GridListTile,
  GridListTileBar,
  SvgIcon,
  BottomNavigation,
  BottomNavigationAction,
  FormControl,
  FormHelperText,
  Paper,
  MenuList,
  Fade,
  CircularProgress,
  DialogTitle,
  Tooltip
} from '@material-ui/core';
import {
  Close,
  Done,
  RadioButtonChecked,
  RadioButtonUnchecked,
  NoteAdd,
  Redo,
  Undo,
  ArrowBack,
  ArrowForward,
  CheckBox,
  CheckBoxOutlineBlank,
  Cancel,
} from '@material-ui/icons';
import { dictionary, getContentCategoryCmb, clientsInfo, getUserInfo, getPermissions,cnfsystem } from '../../axios'
import {
  contentDetail,
  contentLogin,
  contentUpload,
  contentImgUpload,
  contentContentUpload,
  getImagePath,
  contentFileClear,
  getBigImage,
  downloadBigimagePDF,
} from 'mdoc/admin/axios/content'
import { getDepartmentSearch, getUserSearch } from 'mdoc/admin/axios/user'
import { Link } from 'react-router-dom';
import $ from 'jquery';
import Dialog from 'mdoc/utils/myDialog';
import Toast from 'mdoc/utils/toast';
import { messageFormat, getLang } from 'mdoc/utils';
import schema from 'async-validator';
import { getBrowserInfo } from 'mdoc/utils';
// import * as config from 'mdoc/admin/axios/config';
import { Clear } from '@material-ui/icons';
import eventProxy from 'mdoc/utils/eventProxy';
import 'mdoc/admin/components/notify/notify.less';


const localeMap = {
  1: jaLocale,
  2: zhCNLocale,
  3: enLocale,
};
const lang = getLang();

$.fn.rotate = function (angle, whence) {
  var p = this.get(0);

  // we store the angle inside the image tag for persistence
  if (!whence) {
    p.angle = ((p.angle === undefined ? 0 : p.angle) + angle) % 360;
  } else {
    p.angle = angle;
  }
  let rotation = '';
  if (p.angle >= 0) {
    rotation = Math.PI * p.angle / 180;
  } else {
    rotation = Math.PI * (360 + p.angle) / 180;
  }
  var costheta = Math.round(Math.cos(rotation) * 1000) / 1000;
  var sintheta = Math.round(Math.sin(rotation) * 1000) / 1000;
  let canvas = '';
  if (document.all && !window.opera) {
    canvas = document.createElement('img');

    canvas.src = p.src;
    canvas.height = p.height;
    canvas.width = p.width;

    canvas.style.filter = "progid:DXImageTransform.Microsoft.Matrix(M11=" + costheta + ",M12=" + (-sintheta) + ",M21=" + sintheta + ",M22=" + costheta + ",SizingMethod='auto expand')";
  } else {
    canvas = document.createElement('canvas');
    if (!p.oImage) {
      canvas.oImage = new Image();
      canvas.oImage.src = p.src;
    } else {
      canvas.oImage = p.oImage;
    }

    canvas.style.width = canvas.width = Math.abs(costheta * canvas.oImage.width) + Math.abs(sintheta * canvas.oImage.height);
    canvas.style.height = canvas.height = Math.abs(costheta * canvas.oImage.height) + Math.abs(sintheta * canvas.oImage.width);

    var context = canvas.getContext('2d');
    context.save();
    if (rotation <= Math.PI / 2) {
      context.translate(sintheta * canvas.oImage.height, 0);
    } else if (rotation <= Math.PI) {
      context.translate(canvas.width, -costheta * canvas.oImage.height);
    } else if (rotation <= 1.5 * Math.PI) {
      context.translate(-costheta * canvas.oImage.width, canvas.height);
    } else {
      context.translate(0, -sintheta * canvas.oImage.width);
    }
    context.rotate(rotation);
    context.drawImage(canvas.oImage, 0, 0, canvas.oImage.width, canvas.oImage.height);
    context.restore();
  }
  canvas.id = p.id;
  canvas.angle = p.angle;
  p.parentNode.replaceChild(canvas, p);
}

$.fn.rotateRight = function (angle) {
  this.rotate(angle === undefined ? 90 : angle);
}

$.fn.rotateLeft = function (angle) {
  this.rotate(angle === undefined ? -90 : -angle);
}

function ReturnIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M10,9V5L3,12L10,19V14.9C15,14.9 18.5,16.5 21,20C20,15 17,10 10,9Z" />
    </SvgIcon>
  );
}

function AgainIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M21,11L14,4V8C7,9 4,14 3,19C5.5,15.5 9,13.9 14,13.9V18L21,11Z" />
    </SvgIcon>
  );
}

function FileDel(props) {
  return (
    <SvgIcon {...props}>
      <path d="M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M13,9H18.5L13,3.5V9M10,14.59L7.88,12.46L6.46,13.88L8.59,16L6.46,18.12L7.88,19.54L10,17.41L12.12,19.54L13.54,18.12L11.41,16L13.54,13.88L12.12,12.46L10,14.59Z" />
    </SvgIcon>
  );
}

function ContentSave(props) {
  return (
    <SvgIcon {...props}>
      <path d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z" />
    </SvgIcon>
  );
}

function Download(props) {
  return (
    <SvgIcon {...props}>
      <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
    </SvgIcon>
  );
}

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  margin: {
    margin: theme.spacing.unit
  },
  bootstrapRoot: {
    'label + &': {
      marginTop: theme.spacing.unit * 3,
    },
  },
  bootstrapFileRoot: {
    'label + &': {
      marginTop: theme.spacing.unit * 3,
    },
    // width: '290px'
  },
  bootstrapInput: {
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    padding: '5px 6px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  bootstrapFormLabel: {
    lineHeight: '30px',
  },
  bootstrapFormRadioLabel: {
    lineHeight: '30px',
  },
  bootstrapSelect: {
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da!important',
    paddingLeft: '5px'
  },
  Radio: {
    padding: '0px 10px'
  },
  Checkbox: {
    padding: '0px 10px'
  },
  link: {
    textDecoration: 'none'
  },
  links: {
    color: theme.palette.primary.main
  },
  space: {
    height: theme.spacing.unit
  },
  tags: {
    margin: theme.spacing.unit,
  },
  gridList: {
    width: '100%',
    height: 380,
  },
  titleBar: {
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
      'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  fileImg: {
    width: '50px'
  },
  required: {
    color: '#F72D2D'
  },
  buttonlogin: {
    marginLeft: '380px',
    marginTop: '40px'
  },
  buttoncancel: {
    marginLeft: '30px',
    marginTop: '40px'
  },
  cusButton: {
    boxShadow: 'none',
    '-webkitBorderRadius': '0px',
    'borderRadius': '0px'
  },
  buttonProgress: {
    color: '#ff0000',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
    opacity: 0.5
  },
  title: {
    marginLeft: '-20px'
  },
  drop: {
    width: '298px'
  },
  fileInput: {
    display: 'none',
  },
  mask: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: '999',
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    touchAction: 'none',
    // opacity:'0.5'
  },
  fileTips:{
    color: 'rgba(0, 0, 0, 0.54)',
    paddingTop: '5px'
  }
});

class ContentEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      selectedRowKeys: [], // Check here to configure the default column
      data: [],
      permissions: getPermissions() || [],
      // loading: false,
      dictWord: {
        'content_base_information': '',
        'notice_title': '',
        'published_department': '',
        'published_user_name': '',
        'content_description': '',
        'content_publish_information': '',
        'category': '',
        'department_specified_release': '',
        'user_appoint': '',
        'read_expires_period': '',
        'content_upload_detail': '',
        'release_method': '',
        'mixture': '',
        'download': '',
        'streaming': '',
        'upload_file': '',
        'file_select': '',
        'upload': '',
        'clear': '',
        'browse_select': '',
        'epub_browse': '',
        'pdf_browse': '',
        'cover_image': '',
        'first_page_uses_cover_image': '',
        'page_methods': '',
        'left_methods': '',
        'right_methods': '',
        'side_special': '',
        'side_special_page_count': '',
        'invalid': '',
        'valid': '',
        '1screen_2page_show': '',
        '1screen_1page_show': '',
        'registration': '',
        'page_edit': '',
        'user_search': '',
        'ok': '',
        'original_return': '',
        'start_again': '',
        'select_record': '',
        'insert_record': '',
        'delete_record': '',
        'after': '',
        'before': '',
        'left_90degrees': '',
        'right_90degrees': '',
        'department_search': '',
        'msg_warning_content_information': '',
        'yes': '',
        'cancel': '',
        'close': '',
        'msg_error_not_null_with_item': '',
        'msg_error_upload_file_type_invalid': '',
        'msg_can_not_done': '',
        'msg_error_no_record_selected': '',
        'user_name': '',
        'department_designation': '',
        'msg_error_not_select_file': '',
        'confirmation': '',
        'msg_error_endate_greater_than_start_date': '',
        'msg_error_file_size_over_length': '',
        'msg_insufficient_size_on_disk': '',
        'msg_error_record_exists': '',
        'user_id': '',
        'department': '',
        'msg_error_over_length_with_item': '',
        'public': '',
        'non_public': '',
        'notice_open_state': '',
        'book_open_state': '',
        'msg_error_self_category_select': '',
        'printed_department_appoint': '',
        'printed_user_appoint': '',
        'link': '',
        'content_link': '',
        'content': '',
        'save_record': '',
        'load_more': '',
        'push_notice': '',
        'mail_delivery': '',
        'content_update_notification': '',
        'change_summary': '',
        'msg_error_value_invalid':'',
        'upload_only_files_type':'',
        'max_file_size':'',
        'upload_only_image_files':'',
      },
      formData: {
        title: {
          value: '',
          error: false,
          errorMsg: ''
        },
        publisher: {
          value: '',
          error: false,
          errorMsg: ''
        },
        author: {
          value: '',
          error: false,
          errorMsg: ''
        },
        introduction: {
          value: '',
          error: false,
          errorMsg: ''
        },
        changeSummary: {
          value: '',
          error: false,
          errorMsg: ''
        },
        category: {
          width: '',
          value: '',
          error: false,
          errorMsg: ''
        },
        DepartmentTags: {
          value: [],
          error: false,
          errorMsg: ''
        },
        UserTags: {
          value: [],
          error: false,
          errorMsg: ''
        },
        effectiveStartDate: {
          value: null,
          error: false,
          errorMsg: ''
        },
        effectiveEndDate: {
          value: null,
          error: false,
          errorMsg: ''
        },
        isOpen: {
          value: '0',
          error: false,
          errorMsg: ''
        },
        downloadWay: {
          value: '0',
          error: false,
          errorMsg: ''
        },
        readCount: {
          value: '0',
          error: false,
          errorMsg: ''
        },
        coverUuid: {
          value: '',
          error: false,
          errorMsg: ''
        },
        coverName: {
          value: '',
          error: false,
          errorMsg: ''
        },
        firstPage: {
          value: false
        },
        pushDelivery: {
          value: false
        },
        mailDelivery: {
          value: false
        },
        isHorizontal: {
          value: '0',
          error: false,
          errorMsg: ''
        },
        contentLink: {
          value: '0',
          error: false,
          errorMsg: '',
        },
        links: {
          value: '',
          error: false,
          errorMsg: '',
        },
        flip: {
          value: '0',
          error: false,
          errorMsg: ''
        },
        horizontalPageCount: {
          value: '1',
          error: false,
          errorMsg: ''
        },
        createIp: {
          value: getBrowserInfo()[2],
        },
        fileName: {
          value: '',
          error: false,
          errorMsg: ''
        },
        fileUuid: {
          value: '',
          error: false,
          errorMsg: ''
        },
        folderUuid: {
          value: '',
          error: false,
          errorMsg: ''
        },
        fileType: {
          value: '',
        },
        bookIsClear: {
          value: 0,
        },
        oldFileUuid: {
          value: '',
        },
        oldCoverUuid: {
          value: '',
        },
        printingRelease: {
          value: [],
          error: false,
          errorMsg: ''
        },
        printingUser: {
          value: [],
          error: false,
          errorMsg: ''
        }
      },
      dialogEdit: false,
      dialogOpenSearch: false,
      dialogOpenSearchUser: false,
      dialogOpenSearchPrinting: false,
      dialogOpenSearchPrintUser: false,
      department: [],
      user: [],
      printingRelease: [],
      printingUser: [],
      // oldFileData:[],
      bookId: '',
      clientId: '',
      categoryData: null,

      dialogOpen: false,
      pdfFile: null,
      fileDataAll: {},
      fileOptHistory: 0,
      currentFileData: [],
      fileSel: -1,
      multipleFileSel: [],
      pdfEditable: false,
      isSelectBox: false,
      pdfUpLoading: false,
      pdfEditImgLoading: false,
      isDownPdfImg: false,
      loadingMore: false,
      loadMoreImgShow: true,
      LoadEnlargeImg: {},

      imgFile: null,
      imgEditable: false,
      imgUpLoading: false,
      enlargeImgFlag: false,
      singleImgIndex: -1,
      singleImgSrc: '',
      singleImgData: {},
      //
      previousDisabled: true,//元に戻す
      nextDisabled: true,//やり直し
      addDisabled: false,//挿入
      delDisabled: true,//削除
      upDisabled: true,//前へ
      downDisabled: true,//後へ
      leftDisabled: true,//左90度
      rightDisabled: true,//右90度
      disabledAll: false,
      disabledMp4: false,

      pickyStatus: false,
      pickyTime: '2019/03/24 14:59',
      okLoading: false,
      pageLoading: false,
      file_size:0,
      file_max_size:0,
    };

    this.currentFileIndex = 0;
    this.currentFileStep = 10;
    this.currentFileLength = 10;
  }

  UNSAFE_componentWillMount() {
    this.start(this.state);
    if (!this.state.permissions.includes(8)) {
      this.setState({
        disabledAll: true
      });
    }
  }

  componentDidMount() {
    let formData = this.state.formData;
    let width = parseInt(($('#title').css('width')).replace('px', '')) / 2
    formData['category'] = Object.assign(this.state['formData']['category'], { width: width + 'px' });
    this.setState({
      formData: formData
    });
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  sortArray(id, oldData) {
    let newsArray = [];
    let j = 0;
    ParentArry(id);

    function ParentArry(id) {
      for (let i in oldData) {
        if (oldData[i].parentId === id) {
          newsArray[j] = oldData[i];
          j++;
          ParentArry(oldData[i].categoryId, newsArray, j);
        }
      }
    }

    return newsArray;
  }

  start = (state) => {
    // this.setState({loading: true});
    let dict = {}
    dictionary(state.dictWord).then(res => {
      for (let key in res) {
        let val = res[key];
        dict[val.dictKey] = val.dictValue;
      }
      this.setState({
        dictWord: dict,
      })
    })
    cnfsystem("file_size").then(res => {
      let file_max_size = res * 1024 * 1024 * 1024;
      this.setState({
        file_size: res,
        file_max_size: file_max_size,
      })
    })
    //get category
    getContentCategoryCmb().then(res => {
      let results = this.sortArray(0, res.results);
      this.setState({
        categoryData: results,
      })
    })
    if (this.props.match.params.id !== undefined) {
      let bookId = this.props.match.params.id;
      let formData = this.state.formData;
      this.setState({
        loading: true,
        pageLoading: true,
      });
      contentDetail(bookId).then(res => {
        const detail = res.results.docTblBookList[0];
        let startData = detail['effectiveStartDate'] ? new Date(detail['effectiveStartDate']) : null;
        let effectiveStartDate = Object.assign(this.state['formData']['effectiveStartDate'], { value: startData });
        formData['effectiveStartDate'] = effectiveStartDate;

        let endData = detail['effectiveEndDate'] ? new Date(detail['effectiveEndDate']) : null;
        let effectiveEndDate = Object.assign(this.state['formData']['effectiveEndDate'], { value: endData });
        formData['effectiveEndDate'] = effectiveEndDate;

        let title = Object.assign(this.state['formData']['title'], { value: detail['title'] });
        formData['title'] = title;
        formData['fileType'] = Object.assign(this.state['formData']['fileType'], { value: detail['docType'] });
        let publisher = Object.assign(this.state['formData']['publisher'], { value: detail['publisher'] });
        formData['publisher'] = publisher;
        let author = Object.assign(this.state['formData']['author'], { value: detail['author'] });
        formData['author'] = author;
        let introduction = Object.assign(this.state['formData']['introduction'], { value: detail['introduction'] });
        formData['introduction'] = introduction;
        let category = Object.assign(this.state['formData']['category'], { value: parseInt(detail['docMstBookCategory']['categoryId']) });
        formData['category'] = category;
        let dep = [];
        let user = [];
        let printing = [];
        let printUser = [];
        for (let key in detail['bookEffectiveReceive']) {
          let value = detail['bookEffectiveReceive'][key];
          if (value['docMstBookEffectiveReceivePK']['receiveType'] === 1) {
            if (value['docMstDepartment']) {
              dep.push({
                id: value['docMstDepartment']['id'],
                name: value['docMstDepartment']['departmentName'],
              });
            }
          } else if (value['docMstBookEffectiveReceivePK']['receiveType'] === 2) {
            if (value['docTblUser']) {
              user.push({
                id: value['docTblUser']['id'],
                name: value['docTblUser']['name'],
              });
            }
          }
        }
        detail.bookPrintEffectiveReceive.forEach(item => {
          if (item.docMstBookPrintEffectiveReceivePK.receiveType === 1) {
            if (item.docMstDepartment) {
              printing.push({
                id: item.docMstDepartment.id,
                name: item.docMstDepartment.departmentName
              })
            }
          } else if (item.docMstBookPrintEffectiveReceivePK.receiveType === 2) {
            if (item.docTblUser) {
              printUser.push({
                id: item.docTblUser.id,
                name: item.docTblUser.name
              })
            }
          }
        })
        let DepartmentTags = Object.assign(this.state['formData']['DepartmentTags'], { value: dep });
        formData['DepartmentTags'] = DepartmentTags;
        let UserTags = Object.assign(this.state['formData']['UserTags'], { value: user });
        formData['UserTags'] = UserTags;
        let printTags = Object.assign(this.state['formData']['printingRelease'], { value: printing });
        formData.printingRelease = printTags;
        let printUserTags = Object.assign(this.state['formData']['printingUser'], { value: printUser });
        formData.printingUser = printUserTags;

        formData['isOpen'] = Object.assign(this.state['formData']['isOpen'], { value: String(detail['isOpen']) });
        let imgEditable = false;
        if (detail['docTblBookDetail']) {
          formData['fileUuid'] = Object.assign(this.state['formData']['fileUuid'], { value: detail['docTblBookDetail']['fileUuid'] });
          formData['oldFileUuid'] = Object.assign(this.state['formData']['oldFileUuid'], { value: detail['docTblBookDetail']['fileUuid'] });
          formData['fileName'] = Object.assign(this.state['formData']['fileName'], { value: detail['docTblBookDetail']['fileName'] });
          formData['folderUuid'] = Object.assign(this.state['formData']['folderUuid'], { value: detail['docTblBookDetail']['fileUuid'] });

          formData['coverUuid'] = Object.assign(this.state['formData']['coverUuid'], { value: detail['docTblBookDetail']['coverUuid'] === 'DEFAULT' ? '' : detail['docTblBookDetail']['coverUuid'] });
          formData['oldCoverUuid'] = Object.assign(this.state['formData']['oldCoverUuid'], { value: detail['docTblBookDetail']['coverUuid'] === 'DEFAULT' ? '' : detail['docTblBookDetail']['coverUuid'] });
          formData['coverName'] = Object.assign(this.state['formData']['coverName'], { value: detail['docTblBookDetail']['coverName'] === 'DEFAULT' ? '' : detail['docTblBookDetail']['coverName'] });
          formData['firstPage'] = Object.assign(this.state['formData']['firstPage'], { value: detail['docType'] === 'link' ? false : detail['docTblBookDetail']['coverName'] === 'DEFAULT' ? false : (detail['docTblBookDetail']['coverUuid'].length > 0 && detail['docTblBookDetail']['coverName'].length > 0) ? false : true });
          imgEditable = (detail['docTblBookDetail']['coverUuid'] === 'DEFAULT' || detail['docTblBookDetail']['coverName'] === 'DEFAULT') ? false : (detail['docTblBookDetail']['coverUuid'].length > 0 && detail['docTblBookDetail']['coverName'].length) ? true : false;

          formData['downloadWay'] = Object.assign(this.state['formData']['downloadWay'], { value: String(detail['docTblBookDetail']['downloadWay']) });
          formData['flip'] = Object.assign(this.state['formData']['flip'], { value: String(detail['docTblBookDetail']['flip']) });
          formData['isHorizontal'] = Object.assign(this.state['formData']['isHorizontal'], { value: String(detail['docTblBookDetail']['isHorizontal']) });
          formData['horizontalPageCount'] = Object.assign(this.state['formData']['horizontalPageCount'], { value: String(detail['docTblBookDetail']['horizontalPageCount']) });
        }
        if (detail['docType'] === 'link') {
          formData['contentLink'] = Object.assign(this.state['formData']['contentLink'], { value: '1' });
          formData['links'] = Object.assign(this.state['formData']['links'], { value: detail['docLink'] });
        } else if (detail['docType'] === 'mp4') {
          this.setState({
            disabledMp4: true,
          })
        }
        this.setState({
          loading: false,
          pageLoading: false,
          formData: formData,
          imgEditable: imgEditable,
          pdfEditable: detail['docType'] === 'pdf' ? true : false,
          currentFileData: detail['docType'] === 'link' ? [] : detail['docTblBookDetail']['pageInfo'],
          clientId: detail['clientId']
        });
      }).catch(err => {
        this.props.history.replace('/admin/content/content');
      });
    }
  }



  handleChange = (filed) => event => {
    let formData = this.state.formData;
    let categoryData = this.state.categoryData;
    if (filed === 'effectiveStartDate' || filed === 'effectiveEndDate') {
      let value = event;
      formData[filed] = Object.assign(this.state['formData'][filed], { value: value});
    } else if (filed === 'firstPage') {
      let value = event.target.checked;
      formData[filed] = Object.assign(this.state['formData'][filed], { value: value});
    } else if (filed === 'mailDelivery' || filed === 'pushDelivery') {
      let value = event.target.checked;
      formData[filed] = Object.assign(this.state['formData'][filed], { value: value});
    } else {
      let value = event.target.value;
      if (getUserInfo().roleId === 2 && filed === 'category') {
        let flag = false;
        for (let key in categoryData) {
          let value = categoryData[key]
          if (value['vaildFlag'] === 0 && event.target.value === value['categoryId']) {
            flag = true
            break
          }
        }
        if (flag) {
          formData[filed] = Object.assign(this.state['formData'][filed], { value: ''});
          Toast.info(this.state.dictWord.msg_error_self_category_select);
        } else {
          formData[filed] = Object.assign(this.state['formData'][filed], { value: value});
        }
      } else {
        formData[filed] = Object.assign(this.state['formData'][filed], { value: value});
      }
    }
    this.setState({
      formData: formData
    });
  };

  checkLength = (count) => event => {
    let formData = this.state.formData;
    let value = { errorMsg: event.target.value.length + '/' + 500, error: false };
    if (event.target.value.length <= 500) {
      value['error'] = false;
    } else {
      value['error'] = true;
    }
    if (count === 'introduction') {
      formData['introduction'] = Object.assign(this.state['formData']['introduction'], value);
    } else {
      formData['changeSummary'] = Object.assign(this.state['formData']['changeSummary'], value);
    }
    this.setState({
      formData: formData
    });
  }

  //department Tags
  handleDelTags = (tagid) => event => {
    let tags = this.state.formData.DepartmentTags.value;
    // tags[tagid]['delFlag']=1
    tags.splice(tagid, 1)
    let formData = this.state.formData;
    formData['DepartmentTags'] = Object.assign(this.state['formData']['DepartmentTags'], { value: tags });
    this.setState({
      formData: formData
    });
  }
  handleSearch = () => {
    this.setState({
      dialogOpenSearch: true,
      show: false,
      name: '',
      department: []
    });
  }
  handleSearchValue = (name, id) => (event) => {
    let formData = this.state.formData;
    let departmentTags = formData.DepartmentTags.value;
    let isSame = false;
    for (var key in formData['DepartmentTags']['value']) {
      let value = formData['DepartmentTags']['value'][key]
      // let del = value['delFlag']
      if (value['id'] === id) {
        isSame = true;
        break;
      }
    }
    if (isSame) {
      Toast.info(messageFormat(this.state.dictWord.msg_error_record_exists, this.state.dictWord.department));
    } else {
      departmentTags.push({
        id: id,
        name: name,
      });
      formData['DepartmentTags'] = Object.assign(this.state['formData']['DepartmentTags'], { value: departmentTags });
      this.setState({
        formData: formData,
        dialogOpenSearch: false
      });
    }
  }


  inputHandleSearch(arg, event) {
    this.setState({
      name: event.target.value
    }, () => {
      getDepartmentSearch({
        'departmentName': this.state.name,
      }).then(res => {
        this.setState({
          show: true
        })
        const department = res.results;
        let dep = [];
        for (var key in department) {
          let value = department[key];
          dep.push({
            id: value['id'],
            name: value['departmentName'],
          });
        }
        if (arg === 'department') {
          this.setState({
            department: dep
          })
        } else if (arg === 'Printing') {
          this.setState({
            printingRelease: dep
          })
        }

      }).catch(function (error) {
        Toast.error(error);
      })
    });
  }
  dialogHandleOff = () => {
    this.setState({
      dialogOpenSearch: false
    });
  }
  //user Tags
  handleDelUserTags = (tagid) => event => {
    let tags = this.state.formData.UserTags.value;
    // tags[tagid]['delFlag']=1
    tags.splice(tagid, 1)
    let formData = this.state.formData;
    formData['UserTags'] = Object.assign(this.state['formData']['UserTags'], { value: tags });
    this.setState({
      formData: formData
    });
  }
  handleSearchUser = () => {
    this.setState({
      dialogOpenSearchUser: true,
      show: false,
      name: '',
      user: []
    });
  }


  handleSearchUserValue = (name, id) => (event) => {
    let formData = this.state.formData;
    let userTags = formData.UserTags.value;
    let isUserSame = false;
    for (var key in formData['UserTags']['value']) {
      let value = formData['UserTags']['value'][key]
      // let del = value['delFlag']
      if (value['id'] === id) {
        isUserSame = true;
        break;
      }
    }
    if (isUserSame) {
      Toast.info(messageFormat(this.state.dictWord.msg_error_record_exists, this.state.dictWord.user_id));
    } else {
      userTags.push({
        id: id,
        name: name,
      });
      formData['UserTags'] = Object.assign(this.state['formData']['UserTags'], { value: userTags });
      this.setState({
        formData: formData,
        dialogOpenSearchUser: false
      });
    }
  }
  inputHandleSearchUser(arg, event) {
    this.setState({
      name: event.target.value
    }, () => {
      getUserSearch({
        'name': this.state.name,
      }).then(res => {
        this.setState({
          show: true
        })
        const user = res.results;
        let userList = [];
        for (var key in user) {
          let value = user[key];
          userList.push({
            id: value['id'],
            name: value['name'],
          });
        }
        if (arg === 'user') {
          this.setState({
            user: userList
          })
        } else if (arg === 'PrintUser') {
          this.setState({
            printingUser: userList
          })
        }

      }).catch(function (error) {
        Toast.error(error);
      })
    });
  }
  dialogHandleFalse = () => {
    this.setState({
      dialogOpenSearchUser: false,
      dialogOpenSearchPrinting: false,
      dialogOpenSearchPrintUser: false
    });
  }

  //printing Tags
  handleSearchPrinting() {
    this.setState({
      dialogOpenSearchPrinting: true,
      show: false,
      name: '',
      printingRelease: []
    });
  }
  handleSearchPrint = (name, id) => (event) => {
    let formData = this.state.formData;
    let printingRelease = formData.printingRelease.value;
    let isSame = false;
    for (var key in formData['printingRelease']['value']) {
      let value = formData['printingRelease']['value'][key]
      // let del = value['delFlag']
      if (value['id'] === id) {
        isSame = true;
        break;
      }
    }
    if (isSame) {
      Toast.info(messageFormat(this.state.dictWord.msg_error_record_exists, this.state.dictWord.department));
    } else {
      printingRelease.push({
        id: id,
        name: name,
      });
      formData['printingRelease'] = Object.assign(this.state['formData']['printingRelease'], { value: printingRelease });
      this.setState({
        formData: formData,
        dialogOpenSearchPrinting: false
      });
    }
  }
  handleDelPrintingTags = (tagid) => event => {
    let tags = this.state.formData.printingRelease.value;
    tags.splice(tagid, 1)
    let formData = this.state.formData;
    formData['printingRelease'] = Object.assign(this.state['formData']['printingRelease'], { value: tags });
    this.setState({
      formData: formData
    });
  }

  //printUser Tags
  handleSearchPrintUser() {
    this.setState({
      dialogOpenSearchPrintUser: true,
      show: false,
      name: '',
      printingUser: []
    });
  }
  handleSearchPrintingUser = (name, id) => (event) => {
    let formData = this.state.formData;
    let printingUser = formData.printingUser.value;
    let isSame = false;
    for (var key in formData['printingUser']['value']) {
      let value = formData['printingUser']['value'][key]
      // let del = value['delFlag']
      if (value['id'] === id) {
        isSame = true;
        break;
      }
    }
    if (isSame) {
      Toast.info(messageFormat(this.state.dictWord.msg_error_record_exists, this.state.dictWord.user_id));
    } else {
      printingUser.push({
        id: id,
        name: name,
      });
      formData['printingUser'] = Object.assign(this.state['formData']['printingUser'], { value: printingUser });
      this.setState({
        formData: formData,
        dialogOpenSearchPrintUser: false
      });
    }
  }

  handleDelPrintUserTags = (tagid) => event => {
    let tags = this.state.formData.printingUser.value;
    tags.splice(tagid, 1)
    let formData = this.state.formData;
    formData['printingUser'] = Object.assign(this.state['formData']['printingUser'], { value: tags });
    this.setState({
      formData: formData
    });
  }

  handlePdfClear = () => {
    let formData = this.state.formData;
    contentFileClear(formData.folderUuid.value, 0, {}).then(res => {
      formData['fileUuid'] = Object.assign(this.state['formData']['fileUuid'], { value: '' });
      formData['fileName'] = Object.assign(this.state['formData']['fileName'], { value: '' });
      formData['fileType'] = Object.assign(this.state['formData']['fileType'], { value: '' });
      formData['bookIsClear'] = Object.assign(this.state['formData']['bookIsClear'], { value: 1 });
      this.setState({
        formData: formData,
        pdfFile: null,
        fileDataAll: [],
        fileOptHistory: 0,
        currentFileData: [],
        fileSel: -1,
        multipleFileSel: [],
        pdfEditable: false,
        isSelectBox: false,
        pdfUpLoading: false,
        pdfEditImgLoading: false,
        isDownPdfImg: false,
        disabledMp4: false,
      })
    }).catch(err => {
      Toast.error(err)
    })
  }


  onPdfDrop(event) {
    let me = this;
    let formData = me.state.formData;
    let files = event.target.files || [];
    if (files.length < 1) return;
    let file = files[0];
    let name = file.name;
    let type = name.substr(name.lastIndexOf(".") + 1).toLowerCase();//获得文件后缀名
    if (['pdf', 'mp4', 'epub'].indexOf(type) < 0) {
      Toast.error(me.state.dictWord['msg_error_upload_file_type_invalid']);
      return;
    }
    if (file.size > me.state.file_max_size) {
      Toast.error(me.state.dictWord['msg_error_file_size_over_length'].replace('%s', me.state.file_size));
      return false;
    }
    if (type === 'mp4') {
      formData['flip'] = Object.assign(me.state['formData']['flip'], { value: '0' });
      formData['isHorizontal'] = Object.assign(me.state['formData']['isHorizontal'], { value: '0' });
      me.setState({
        formData,
        disabledMp4: true,
      })
    } else {
      me.setState({
        formData,
        disabledMp4: false,
      })
    }
    clientsInfo().then(res => {
      if (res.remainCapacity < file.size) {
        Toast.error(me.state.dictWord['msg_insufficient_size_on_disk']);
      } else {
        let formData = me.state.formData;
        if (type.indexOf('pdf') >= 0) {
          formData['fileType'] = Object.assign(me.state['formData']['fileType'], { value: 'pdf' });
        } else if (type.indexOf('epub') >= 0) {
          formData['fileType'] = Object.assign(me.state['formData']['fileType'], { value: 'epub' });
        } else if (type.indexOf('mp4') >= 0) {
          formData['fileType'] = Object.assign(me.state['formData']['fileType'], { value: 'mp4' });
        }

        formData['fileName'] = Object.assign(me.state['formData']['fileName'], { value: file.name });
        me.setState({
          formData: formData,
          pdfFile: [file],
          pdfEditable: false,
        })
      }
    }).catch(function (err) {
      Toast.error(err);
    })
  }

  fileButton(id) {
    let fileInput = document.getElementById(id);
    fileInput.value = '';
    if (id === 'add-file') {
      fileInput.click()
    }
  }
  handlePdfUpload = () => {
    let pdfFile = this.state.pdfFile;

    let data = new FormData();
    pdfFile.forEach(item => {
      data.append("upfile", item);
      if (this.state.formData.folderUuid.value.length > 0) {
        data.append("folderUuid", this.state.formData.folderUuid.value);
      }
    })
    this.setState({
      fileOptHistory: 0,
      fileDataAll: {},
      pdfUpLoading: true
    });
    contentContentUpload(data).then(res => {
      let formData = this.state.formData;
      if (formData.oldFileUuid.value.length > 0) {
        formData['fileUuid'] = Object.assign(this.state['formData']['fileUuid'], { value: formData.oldFileUuid.value });
      } else {
        formData['fileUuid'] = Object.assign(this.state['formData']['fileUuid'], { value: res.fileUuid });
      }
      if (formData.folderUuid.value.length < 1) {
        formData['folderUuid'] = Object.assign(this.state['formData']['folderUuid'], { value: res.folderUuid });
      }
      let pdfEditData = res;
      for (let fileKey in pdfEditData.imageUuids) {
        let currentFileData = this.state.currentFileData;
        let page = pdfEditData.pageUuids[fileKey];
        let folderUuid = formData.folderUuid.value.length > 0 ? formData.folderUuid.value : res.folderUuid;
        let file = {
          folderUuid: folderUuid,
          pageUuid: page,
          num: parseInt(fileKey) + 1,
          rotation: 0,
          optFlg: 4,
        };
        currentFileData[fileKey] = file;
        this.setState({
          currentFileData: currentFileData,
        });
      }
      this.setState({
        pdfEditable: this.state.formData.fileType.value === 'pdf' ? true : false,
        pdfUpLoading: false,
        formData: formData,
        isDownPdfImg: false,
      });
    }).catch(error => {
      Toast.error(error);
      this.setState({
        pdfUpLoading: false,
      });
    })
  }
  handleEditFile = event => {
    if (this.state.isDownPdfImg) {
      this.setState({
        dialogEdit: true,
      });
    } else {
      this.setState({
        pdfEditImgLoading: true,
        loadingMore: true,
        addDisabled: true,
      });
      let { currentFileData, formData } = this.state;
      let pathInfoData = $.extend([], currentFileData, true);
      let resAll = [];
      for (let i = 0; i < pathInfoData.length; i++) {
        if (i < this.currentFileLength) {
          let img = pathInfoData[i].pageUuid;
          let page = pathInfoData[i].pageUuid;
          let file = {
            // img: imgRes,
            pageUuid: page,
            num: parseInt(i) + 1,
            rotation: 0,
            optFlg: 3
          };
          currentFileData[i] = file;
          this.setState({
            dialogEdit: true,
            isDownPdfImg: true,
            pdfEditImgLoading: false,
            currentFileData: currentFileData,
          });
          resAll.push(getImagePath(formData.folderUuid.value, img));
        }

      }
      Promise.all(resAll).then(imgRes => {
        let currentFileData = this.state.currentFileData;
        imgRes.forEach((item, index) => {
          currentFileData[index]['img'] = item;
        });
        this.setState({
          currentFileData: currentFileData,
          loadingMore: false,
          addDisabled: false,
        });
        if (this.currentFileLength >= currentFileData.length) {
          this.setState({
            loadMoreImgShow: false,
          })
        } else {
          this.currentFileIndex = this.currentFileLength;
          this.currentFileLength = this.currentFileLength + this.currentFileStep;
        }
      });
    }
  }

  fileEditDialogHandleClose = () => {
    this.setState({
      dialogEdit: false,
      fileOptHistory: 0,
      fileSel: -1,
      fileDataAll: {}
    });
  }

  fileDataCount() {
    let { currentFileData } = this.state;
    let len = 0;
    for (let key in currentFileData) {
      if (currentFileData[key] && currentFileData[key]['optFlg'] !== 1) {
        len++;
      }
    }
    return len;
  }

  handleFileSelect = (num) => event => {
    let { multipleFileSel, loadingMore } = this.state;
    if (loadingMore) {
      return;
    }
    if (this.state.isSelectBox) {
      if (multipleFileSel.includes(num)) {
        let index = multipleFileSel.indexOf(num);
        multipleFileSel.splice(index, 1)
      } else {
        multipleFileSel.push(num);
      }
      this.setState({
        multipleFileSel: multipleFileSel,
        delDisabled: (multipleFileSel.length > 0 && multipleFileSel.length < this.fileDataCount()) ? false : true,//削除
      });
    } else {
      this.setState({
        fileSel: num,
        delDisabled: this.fileDataCount() > 1 ? false : true,//削除
        upDisabled: this.fileDataCount() > 1 ? false : true,//前へ
        downDisabled: this.fileDataCount() > 1 ? false : true,//後へ
        leftDisabled: false,//左90度
        rightDisabled: false,//右90度
      });
    }
  }

  handleEnlargeImg(index) {
    let { formData, currentFileData, loadingMore } = this.state;
    if (loadingMore) {
      return;
    }
    let singleImgData = currentFileData[index];
    let LoadEnlargeImg = {};
    LoadEnlargeImg[index] = true;
    this.setState({
      LoadEnlargeImg: LoadEnlargeImg,
    })
    if (singleImgData.bigImg) {
      this.setState({
        singleImgIndex: index,
        singleImgSrc: singleImgData.bigImg,
        singleImgData,
        enlargeImgFlag: true,
        okLoading: true,
        LoadEnlargeImg: {},
      })
    } else {
      getBigImage(formData.folderUuid.value, singleImgData.pageUuid).then(res => {
        singleImgData['bigImg'] = res;
        this.setState({
          singleImgIndex: index,
          singleImgSrc: res,
          singleImgData,
          enlargeImgFlag: true,
          okLoading: true,
          LoadEnlargeImg: {},
        })
      })
    }
  }

  loadMoreImg() {
    let { currentFileData, formData } = this.state;
    let pathInfoData = $.extend([], currentFileData, true);
    this.setState({
      loadingMore: true,
      addDisabled: true,
    });
    let resAll = [];
    for (let i = this.currentFileIndex; i < pathInfoData.length; i++) {
      if (i < this.currentFileLength) {

        let img = pathInfoData[i].pageUuid;
        let page = pathInfoData[i].pageUuid;
        let file = {
          pageUuid: page,
          num: parseInt(i) + 1,
          rotation: 0,
          optFlg: 3
        };
        currentFileData[i] = file;
        this.setState({
          dialogEdit: true,
          isDownPdfImg: true,
          pdfEditImgLoading: false,
          currentFileData: currentFileData,
        });
        resAll.push(getImagePath(formData.folderUuid.value, img));
      }
    }
    Promise.all(resAll).then(imgRes => {
      let { currentFileData, fileDataAll } = this.state;
      imgRes.forEach((item, index) => {
        currentFileData[this.currentFileIndex + index]['img'] = item;
        let pageUuid = currentFileData[this.currentFileIndex + index]['pageUuid'];
        for (let key in fileDataAll) {
          let value = fileDataAll[key];
          value.forEach(itemHis => {
            if (itemHis['pageUuid'] === pageUuid) {
              itemHis['img'] = item;
            }
          });
        }
      });
      this.setState({
        currentFileData: currentFileData,
        loadingMore: false,
        addDisabled: false,
        fileDataAll
      });
      this.currentFileIndex = this.currentFileLength;
      if (this.currentFileLength >= currentFileData.length) {
        this.setState({
          loadMoreImgShow: false,
        });
      } else {
        let total = this.currentFileLength + this.currentFileStep;
        this.currentFileLength = total > currentFileData.length ? currentFileData.length : total;
      }
    });

  }

  closeEnlargeImg() {
    this.setState({
      enlargeImgFlag: false
    })
  }

  imgLoad = (src, num, rotation) => event => {
    let image = document.createElement('img');
    image.src = src;
    let canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    canvas.getContext("2d").drawImage(image, 0, 0);

    canvas.id = 'img' + num;
    canvas.src = src;
    $(canvas).attr('style', 'width:100%')
    $('#imgBox' + num).html(canvas);
    if (rotation !== undefined) {
      if (rotation > 0) {
        $('#img' + num).rotateRight(Math.abs(rotation));
      } else {
        $('#img' + num).rotateLeft(Math.abs(rotation));
      }
    }
    if (num === 'Enlarge') {
      $('#img' + num).css('width', '400px');
    } else {
      $('#img' + num).css('width', '100%');
    }
  }

  reloadImg(currentFileData, oldData) {
    for (let key in oldData) {
      if (!oldData[key]['img'] || oldData[key]['img'] === undefined) {
        continue;
      }
      for (let key2 in currentFileData) {
        let oldRotate = oldData[key]['rotation'];
        let page = oldData[key]['pageUuid'];
        let curPage = currentFileData[key2]['pageUuid'];
        if (page === curPage) {
          let curRotate = currentFileData[key2]['rotation'];
          let newRotate = oldRotate - curRotate;
          if (currentFileData.length > oldData.length) {
            if (newRotate >= 0) {
              $('#img' + key).rotateRight(newRotate);
            } else {
              $('#img' + key).rotateLeft(Math.abs(newRotate));
            }
            $('#img' + key).css('width', '100%');
            break;
          } else {
            if (newRotate >= 0) {
              $('#img' + key2).rotateRight(newRotate);
            } else {
              $('#img' + key2).rotateLeft(Math.abs(newRotate));
            }
            $('#img' + key2).css('width', '100%');
            break;
          }
        }
      }
    }
  }

  getFileDataAllLen = () => {
    let fileDataAll = this.state.fileDataAll;
    let arr = Object.keys(fileDataAll);
    return arr.length;
  }
  previous = event => {
    if (this.state.isSelectBox) {
      Toast.info(this.state.dictWord.msg_can_not_done);
      return;
    }
    let { fileOptHistory, fileDataAll, currentFileData } = this.state;
    this.setState({
      loading: true,
    });
    if (!fileDataAll['file' + fileOptHistory]) {
      fileDataAll['file' + fileOptHistory] = currentFileData;
      this.setState({
        fileDataAll: fileDataAll,
      });
    }

    fileOptHistory--;
    let previousData = fileDataAll['file' + fileOptHistory];
    if (previousData !== undefined) {
      this.reloadImg(currentFileData, previousData);
      this.setState({
        fileSel: -1,
        multipleFileSel: [],
        loading: false,
        fileOptHistory: fileOptHistory,
        currentFileData: previousData,
        previousDisabled: fileOptHistory > 0 ? false : true,//元に戻す
        nextDisabled: false,//やり直し
        addDisabled: false,//挿入
        delDisabled: true,//削除
        upDisabled: true,//前へ
        downDisabled: true,//後へ
        leftDisabled: true,//左90度
        rightDisabled: true,//右90度
      });
    } else {
    }
  }
  next = event => {
    if (this.state.isSelectBox) {
      Toast.info(this.state.dictWord.msg_can_not_done);
      return;
    }
    let { fileOptHistory, fileDataAll, currentFileData, } = this.state;

    this.setState({
      loading: true,
    });
    fileOptHistory++;
    let nextData = fileDataAll['file' + fileOptHistory];
    if (nextData !== undefined) {
      this.reloadImg(currentFileData, nextData);
      this.setState({
        fileSel: -1,
        multipleFileSel: [],
        fileOptHistory: fileOptHistory,
        currentFileData: nextData,
        previousDisabled: fileOptHistory > 0 ? false : true,//元に戻す
        nextDisabled: fileOptHistory + 1 < this.getFileDataAllLen() ? false : true,//やり直し
        addDisabled: false,//挿入
        delDisabled: true,//削除
        upDisabled: true,//前へ
        downDisabled: true,//後へ
        leftDisabled: true,//左90度
        rightDisabled: true,//右90度
      });
    }
  }
  multipleSelection = event => {
    this.setState({
      isSelectBox: true,
      fileSel: -1,
      // previousDisabled:true,//元に戻す
      // nextDisabled:true,//やり直し
      addDisabled: true,//挿入
      delDisabled: true,//削除
      upDisabled: true,//前へ
      downDisabled: true,//後へ
      leftDisabled: true,//左90度
      rightDisabled: true,//右90度
    });
  }
  multipleSelectionCancel = event => {
    this.setState({
      isSelectBox: false,
      multipleFileSel: [],
      // previousDisabled:true,//元に戻す
      // nextDisabled:true,//やり直し
      addDisabled: false,//挿入
      delDisabled: true,//削除
      upDisabled: true,//前へ
      downDisabled: true,//後へ
      leftDisabled: true,//左90度
      rightDisabled: true,//右90度
    });
  }

  addArray(oldData, index, newData) {
    let newsArray = [];
    for (let key in oldData) {
      newsArray.push(oldData[key]);
    }
    if (index > -1) {
      newsArray.splice(index + 1, 0, newData);

      this.setState({
        fileSel: index + 1
      });
    } else {
      let lastIndex = this.currentFileLength - this.currentFileStep;
      newsArray.splice(lastIndex, 0, newData);
    }
    this.currentFileLength += 1;
    this.currentFileIndex += 1;
    return newsArray;
  }
  addFile(event) {
    let me = this;
    let files = event.target.files || [];
    if (files.length < 1) return;
    let file = files[0];
    let name = file.name;
    let type = name.substr(name.lastIndexOf(".")).toLowerCase();//获得文件后缀名
    if (type.indexOf('pdf') < 1) {
      Toast.error(me.state.dictWord['msg_error_upload_file_type_invalid']);
      return;
    }
    if (file.size > me.state.file_max_size) {
      Toast.error(me.state.dictWord['msg_error_file_size_over_length'].replace('%s', me.state.file_size));
      return false;
    }

    let { formData, fileOptHistory, fileDataAll, currentFileData } = this.state;
    fileDataAll['file' + fileOptHistory] = currentFileData;
    fileOptHistory++;
    let data = new FormData();
    for (let key in files) {
      let item = files[key];
      if (typeof item === 'object') {
        data.append("upfile", item);
        if (formData.folderUuid.value.length > 0) {
          data.append("folderUuid", formData.folderUuid.value);
        }
      }
    }
    this.setState({
      addDisabled: true
    })
    contentContentUpload(data).then(res => {
      let resAll = [];
      let data = [];
      for (let i = 0; i < res.imageUuids.length; i++) {
        let img = res.imageUuids[i];
        let page = res.pageUuids[i];
        let file = {
          pageUuid: page,
          num: parseInt(i) + 1,
          rotation: 0,
          optFlg: 3
        };
        data.push(file);
        resAll.push(getImagePath(formData.folderUuid.value, img));
      }
      Promise.all(resAll).then(imgRes => {
        imgRes.forEach((item, index) => {
          data[index]['img'] = item;
          let currentFileData = this.state.currentFileData;
          let newFileData = this.addArray(currentFileData, this.state.fileSel, data[index]);

          this.setState({
            currentFileData: newFileData
          });
        });
        this.setState({
          fileSel: -1,
          fileOptHistory: fileOptHistory,
          fileDataAll: fileDataAll,
          previousDisabled: fileOptHistory > 0 ? false : true,//元に戻す
          nextDisabled: fileOptHistory <= fileDataAll.length ? false : true,//やり直し
          addDisabled: false,//挿入
          delDisabled: true,//削除
          upDisabled: true,//前へ
          downDisabled: true,//後へ
          leftDisabled: true,//左90度
          rightDisabled: true,//右90度
        });

      });
    }).catch(error => {
      Toast.error(error);
    })
  }

  delArray(oldData, indexs) {
    let newsArray = [];
    for (let key in oldData) {
      newsArray.push(oldData[key]);
    }
    for (let indexKey in indexs) {
      if (newsArray[indexs[indexKey]]) {
        if (newsArray[indexs[indexKey]]['optFlg'] === 4) {
          delete newsArray[indexs[indexKey]];
        } else {
          newsArray[indexs[indexKey]]['optFlg'] = 1;
        }
      }
    }
    return newsArray;
  }

  delFile = event => {
    let { fileDataAll, fileSel, fileOptHistory, currentFileData, isSelectBox, multipleFileSel } = this.state;
    if (isSelectBox) {
      if (multipleFileSel.length < 1) {
        Toast.info(this.state.dictWord.msg_error_no_record_selected);
        return;
      }
    } else {
      if (fileSel < 0) {
        Toast.info(this.state.dictWord.msg_error_no_record_selected);
        return;
      } else {
        multipleFileSel.push(fileSel);
      }
    }
    fileDataAll['file' + fileOptHistory] = currentFileData;
    fileOptHistory++;
    this.setState({
      fileSel: -1,
      fileOptHistory: fileOptHistory,
      fileDataAll: fileDataAll,
      previousDisabled: fileOptHistory > 0 ? false : true,//元に戻す
      nextDisabled: fileOptHistory <= fileDataAll.length ? false : true,//やり直し
      addDisabled: false,//挿入
      delDisabled: true,//削除
      upDisabled: true,//前へ
      downDisabled: true,//後へ
      leftDisabled: true,//左90度
      rightDisabled: true,//右90度
    });
    let newsArray = $.extend(true, [], currentFileData);
    let newFileData = this.delArray(newsArray, multipleFileSel);
    this.setState({
      currentFileData: newFileData
    });
  }

  swapArray(oldData, index1, index2) {
    let newsArray = [];
    for (let key in oldData) {
      newsArray.push(oldData[key]);
    }
    let c = newsArray[index1];
    newsArray[index1] = newsArray[index2];
    newsArray[index2] = c;
    return newsArray;
  }

  fileUp = event => {
    if (this.state.isSelectBox) {
      Toast.info(this.state.dictWord.msg_can_not_done);
      return;
    }
    let { fileDataAll, fileSel, fileOptHistory, currentFileData } = this.state;

    if (fileSel >= 0) {
      if (fileSel !== 0) {
        fileDataAll['file' + fileOptHistory] = currentFileData;
        fileOptHistory++;
        let newFileData = this.swapArray(currentFileData, fileSel, fileSel - 1);
        this.setState({
          fileSel: fileSel - 1,
          fileOptHistory: fileOptHistory,
          fileDataAll: fileDataAll,
          currentFileData: newFileData,
          previousDisabled: fileOptHistory > 0 ? false : true,//元に戻す
          nextDisabled: fileOptHistory <= fileDataAll.length ? false : true,//やり直し
        });
      } else {
        Toast.warning(this.state.dictWord.msg_can_not_done);
      }
    } else {
      Toast.info(this.state.dictWord.msg_error_no_record_selected);
    }
  }
  fileDown = event => {
    if (this.state.isSelectBox) {
      Toast.info(this.state.dictWord.msg_can_not_done);
      return;
    }
    let { fileDataAll, fileSel, fileOptHistory, currentFileData } = this.state;
    if (fileSel >= 0) {
      if (fileSel + 1 !== currentFileData.length) {
        fileDataAll['file' + fileOptHistory] = currentFileData;
        fileOptHistory++;

        let newFileData = this.swapArray(currentFileData, fileSel, fileSel + 1);

        this.setState({
          fileOptHistory: fileOptHistory,
          fileSel: fileSel + 1,
          fileDataAll: fileDataAll,
          currentFileData: newFileData,
          previousDisabled: fileOptHistory > 0 ? false : true,//元に戻す
          nextDisabled: fileOptHistory <= fileDataAll.length ? false : true,//やり直し
        });
      } else {
        Toast.warning(this.state.dictWord.msg_can_not_done);
      }
    } else {
      Toast.info(this.state.dictWord.msg_error_no_record_selected);
    }
  }

  rotateArray(oldData, index, type) {
    let newsArray = $.extend(true, [], oldData);
    if (type === 'left') {
      let leftRotate = Number(newsArray[index]['rotation']) - 90;
      if (newsArray[index]['rotation'] <= -360) {
        leftRotate = 0;
      }
      newsArray[index]['rotation'] = leftRotate;
    } else {
      let rightRotate = Number(newsArray[index]['rotation']) + 90;
      if (newsArray[index]['rotation'] >= 360) {
        rightRotate = 0;
      }
      newsArray[index]['rotation'] = rightRotate;
    }
    return newsArray;
  }

  rotateArray1(oldData, type) {
    let newsArray = $.extend(true, {}, oldData);
    if (type === 'left') {
      let leftRotate = Number(newsArray['rotation']) - 90;
      if (newsArray['rotation'] <= -360) {
        leftRotate = 0;
      }
      newsArray['rotation'] = leftRotate;
    } else {
      let rightRotate = Number(newsArray['rotation']) + 90;
      if (newsArray['rotation'] >= 360) {
        rightRotate = 0;
      }
      newsArray['rotation'] = rightRotate;
    }
    return newsArray;
  }


  leftRotate = event => {
    let { singleImgData } = this.state;

    $('#imgEnlarge').rotateLeft(90);
    $('#imgEnlarge').css('width', '400px');
    let newsArray = $.extend(true, [], singleImgData);
    let newFileData = this.rotateArray1(newsArray, 'left');
    this.setState({
      singleImgData: newFileData
    });
  }
  rightRotate = event => {
    let { singleImgData } = this.state;
    $('#imgEnlarge').rotateRight(90);
    $('#imgEnlarge').css('width', '400px');
    let newsArray = $.extend(true, [], singleImgData);
    let newFileData = this.rotateArray1(newsArray, 'right');
    this.setState({
      singleImgData: newFileData
    });
  }

  saveSingleImg = event => {
    let { fileDataAll, fileOptHistory, currentFileData, singleImgIndex, singleImgData } = this.state;
    if (singleImgIndex >= 0) {
      fileDataAll['file' + fileOptHistory] = this.state.currentFileData;
      fileOptHistory++;
      let newsArray = $.extend(true, [], currentFileData);
      newsArray[singleImgIndex] = singleImgData;
      this.reloadImg(currentFileData, newsArray);
      this.setState({
        singleImgIndex: -1,
        fileOptHistory: fileOptHistory,
        fileDataAll: fileDataAll,
        currentFileData: newsArray,
        previousDisabled: fileOptHistory > 0 ? false : true,//元に戻す
        nextDisabled: fileOptHistory <= fileDataAll.length ? false : true,//やり直し
        enlargeImgFlag: false,
      });
    }
  }

  downloadSinglePDF() {
    let { formData, currentFileData, singleImgIndex } = this.state;
    let singleImgData = currentFileData[singleImgIndex];
    downloadBigimagePDF(formData.category.value, formData.fileUuid.value, singleImgData.pageUuid).then(res => {
    }).catch(function (error) {
      Toast.error(error);
    })
  }

  //login
  handleSubmit = () => {
    let descriptor = {
      title: [
        {
          required: true,
          message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.notice_title)
        },
        {
          max: 250,
          required: true,
          message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.notice_title)
        },
      ],
      publisher: [
        {
          required: true,
          message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.published_department)
        },
        {
          max: 128,
          required: true,
          message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.published_department)
        },
      ],
      author: [
        {
          required: true,
          message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.published_user_name)
        },
        {
          max: 128,
          required: true,
          message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.published_user_name)
        },
      ],
      introduction: [
        {
          max: 500,
          message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.content_description)
        },
      ],
      changeSummary: [
        {
          max: 500,
          message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.change_summary)
        },
      ],
      category: [
        {
          required: true,
          message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.category)
        },
      ],
      links: [
        {
          required: true,
          message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.link)

        },
        {
          max: 256,
          required: true,
          message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.link)
        },
      ],
      fileUuid: [
        { required: true, message: this.state.dictWord.msg_error_not_select_file },
      ],
      effectiveEndDate: {
        required: false,
        message: this.state.dictWord.msg_error_endate_greater_than_start_date,
        validator(rule, value, callback, source, options) {
          if (value && source['effectiveStartDate'] && value < source['effectiveStartDate']) {
            callback(new Error(rule.message));
          } else {
            callback();
          }
        }
      }
    }
    const formData = this.state.formData;
    if (formData.contentLink.value === '1') {
      descriptor.fileUuid[0].required = false;
      descriptor.fileUuid[0].message = '';
    } else {
      descriptor.links[0].required = false;
      descriptor.links[0].message = '';
      descriptor.links[1].required = false;
      descriptor.links[1].message = '';
    }
    const validator = new schema(descriptor);
    let resourceData = {};
    for (let index in formData) {
      let item = formData[index];
      let value = item.value;
      resourceData[index] = value;
    }
    validator.validate(resourceData, {
      firstFields: true
    }, (errors, fields) => {
      let formData = this.state.formData;
      let emojiReg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/g;
      let emojierr = [];
      for (let index in formData) {
        formData[index] = Object.assign(this.state['formData'][index], { errorMsg: '', error: false });
        let value = formData[index].value;
        if(value && typeof value !== 'object' && value.length > 0){
          if(value.search(emojiReg) >= 0){
            emojierr.push({'message':this.state.dictWord.msg_error_value_invalid,'field':index});
          }
        }
      }
      if (errors || emojierr.length > 0) {
        if(errors){
          errors.forEach(item => {
            formData[item.field] = Object.assign(this.state['formData'][item.field], {
              errorMsg: item.message,
              error: true
            })
          });
        }
        if(emojierr.length > 0){
          emojierr.forEach(item => {
            formData[item.field] = Object.assign(this.state['formData'][item.field], {
              errorMsg: item.message,
              error: true
            })
          });
        }
        this.setState({
          formData: formData
        });
      }else {
        this.setState({
          dialogOpen: true,
          formData: formData,
          okLoading: false,
        });
      }
    })
  }
  dialogHandleOK = () => {
    const confirmData = this.state.formData;
    let clientId = this.state.clientId;
    let noticeType = '';
    if (confirmData.contentLink.value === '1' || confirmData.isOpen.value === '1') {
      noticeType = 0;
    } else {
      if (confirmData['pushDelivery']['value'] && confirmData['mailDelivery']['value']) {
        noticeType = 3
      } else if (confirmData['pushDelivery']['value'] && !confirmData['mailDelivery']['value']) {
        noticeType = 1
      } else if (!confirmData['pushDelivery']['value'] && confirmData['mailDelivery']['value']) {
        noticeType = 2
      } else {
        noticeType = 0
      }
    }
    let postData = {
      'title': confirmData['title']['value'],
      'publisher': confirmData['publisher']['value'],
      'author': confirmData['author']['value'],
      'introduction': confirmData['introduction']['value'],
      'effectiveStartDate': confirmData['effectiveStartDate']['value'] ? confirmData['effectiveStartDate']['value'] : '',
      'effectiveEndDate': confirmData['effectiveEndDate']['value'] ? confirmData['effectiveEndDate']['value'] : '',
      "createIp": confirmData['createIp']['value'],
      "docType": confirmData.contentLink.value === '1' ? 'link' : confirmData.fileType.value,
      docLink: confirmData.links.value,
      categoryId: confirmData.category.value,
      isOpen: parseInt(confirmData['isOpen']['value']),
      clientId: this.props.match.params.id !== undefined ? clientId : '',
      noticeType: noticeType,
      updateSummary: confirmData['changeSummary']['value'] ? confirmData['changeSummary']['value'] : '',
      docTblBookDetail: {
        downloadWay: parseInt(confirmData['downloadWay']['value']),
        fileName: confirmData.fileName.value,
        fileUuid: confirmData.fileUuid.value,
        coverUuid: confirmData.firstPage.value === true ? '' : (confirmData.coverName.value.length > 0 && confirmData.coverUuid.value.length > 0) ? confirmData.coverUuid.value : 'DEFAULT',
        coverName: confirmData.firstPage.value === true ? '' : (confirmData.coverName.value.length > 0 && confirmData.coverUuid.value.length > 0) ? confirmData.coverName.value : 'DEFAULT',
        folderUuid: confirmData.folderUuid.value,
        pageInfo: [],
        flip: parseInt(confirmData['flip']['value']),
        bookIsClear: this.props.match.params.id !== undefined ? parseInt(confirmData['bookIsClear']['value']) : 0,
        isHorizontal: parseInt(confirmData['isHorizontal']['value']),
        horizontalPageCount: parseInt(confirmData['isHorizontal']['value']) === 0 ? 1 : parseInt(confirmData['horizontalPageCount']['value']),
      },
      bookEffectiveReceive: [],
      bookPrintEffectiveReceive: []
    };
    this.setState({
      okLoading: true
    });
    confirmData['DepartmentTags'].value.forEach(item => {
      postData['bookEffectiveReceive'].push({
        docMstBookEffectiveReceivePK: {
          "receiveType": 1,
          "receiveId": item['id'],
        }
      })
    })
    confirmData['UserTags'].value.forEach(item => {
      postData['bookEffectiveReceive'].push({
        docMstBookEffectiveReceivePK: {
          "receiveType": 2,
          "receiveId": item['id'],
        }
      })
    })
    confirmData.printingRelease.value.forEach(item => {
      postData['bookPrintEffectiveReceive'].push({
        docMstBookPrintEffectiveReceivePK: {
          "receiveType": 1,
          "receiveId": item['id'],
        }
      })
    })
    confirmData.printingUser.value.forEach(item => {
      postData['bookPrintEffectiveReceive'].push({
        docMstBookPrintEffectiveReceivePK: {
          "receiveType": 2,
          "receiveId": item['id'],
        }
      })
    })
    let num = 1;
    this.state.currentFileData.forEach((item, index) => {
      if (item) {
        postData['docTblBookDetail']['pageInfo'].push({
          pageUuid: item.pageUuid,
          pageNumber: item.optFlg !== 1 ? num : 0,
          rotation: item.rotation,
          optFlg: item.optFlg
        });
        if (item.optFlg !== 1) {
          num++;
        }
      }
    })
    let me = this;
    if (this.props.match.params.id !== undefined) {
      let bookId = this.props.match.params.id;
      postData['id'] = bookId;
      contentUpload(postData).then(res => {
        clientsInfo().then(data => {
          eventProxy.trigger('loginNumChange', data);
          this.props.history.push('/admin/content/content');
        }).catch(function (err) {
          Toast.error(err);
          me.setState({
            dialogOpen: false,
            okLoading: false
          });
        });
      }).catch(function (error) {
        Toast.error(error);
        me.setState({
          dialogOpen: false,
          okLoading: false
        });
      })
    } else {
      contentLogin(postData).then(res => {
        clientsInfo().then(data => {
          eventProxy.trigger('loginNumChange', data);
          this.props.history.push('/admin/content/content');
        }).catch(function (err) {
          Toast.error(err);
          me.setState({
            dialogOpen: false,
            okLoading: false
          });
        })
      }).catch(function (error) {
        Toast.error(error);
        me.setState({
          dialogOpen: false,
          okLoading: false
        });
      })
    }

  }
  dialogHandleClose = () => {
    this.setState({
      dialogOpen: false,
      fileOptHistory: 0,
      fileDataAll: {},
      fileSel: -1
    });
  }
  onImgDrop(event) {
    let me = this;
    let files = event.target.files || [];
    if (files.length < 1) return;
    let file = files[0];
    let name = file.name;
    let type = name.substr(name.lastIndexOf(".")).toLowerCase();//获得文件后缀名
    if (['.gif', '.png', '.jpg', '.jpeg'].indexOf(type) < 0) {
      Toast.error(me.state.dictWord['msg_error_upload_file_type_invalid']);
      return;
    }
    if (file.size > me.state.file_max_size) {
      Toast.error(me.state.dictWord['msg_error_file_size_over_length'].replace('%s', me.state.file_size));
      return false;
    }
    clientsInfo().then(res => {
      if (res.remainCapacity < file.size) {
        Toast.error(me.state.dictWord['msg_insufficient_size_on_disk']);
      } else {
        let formData = me.state.formData;
        formData['coverName'] = Object.assign(me.state['formData']['coverName'], { value: file.name });
        formData['coverUuid'] = Object.assign(me.state['formData']['coverUuid'], { value: '' });
        me.setState({
          formData: formData,
          imgFile: [file]
        })
      }
    }).catch(function (err) {
      Toast.error(err);
    })
  }
  handleImgUpload = () => {
    let imgFile = this.state.imgFile;
    let data = new FormData();
    imgFile.forEach(item => {
      data.append("upfile", item);
      if (this.state.formData.folderUuid.value.length > 0) {
        data.append("folderUuid", this.state.formData.folderUuid.value);
      }
      if (this.state.formData.oldCoverUuid.value.length > 0) {
        data.append("fileUuid", this.state.formData.oldCoverUuid.value);
      }
    })
    this.setState({
      imgUpLoading: true
    });
    contentImgUpload(data).then(res => {
      let formData = this.state.formData;
      if (formData.folderUuid.value.length < 1) {
        formData['folderUuid'] = Object.assign(this.state['formData']['folderUuid'], { value: res.folderUuid });
      }
      if (formData.oldCoverUuid.value.length > 0) {
        formData['coverUuid'] = Object.assign(this.state['formData']['coverUuid'], { value: formData.oldCoverUuid.value });
      } else {
        formData['coverUuid'] = Object.assign(this.state['formData']['coverUuid'], { value: res.fileUuid });
      }
      this.setState({
        formData: formData,
        imgUpLoading: false,
        imgEditable: true
      });
    }).catch(error => {
      Toast.error(error);
      this.setState({
        imgUpLoading: false,
      });
    })
  }
  handleImgClear = () => {
    let formData = this.state.formData;
    contentFileClear(formData.folderUuid.value, 1, {}).then(res => {
      formData['coverName'] = Object.assign(this.state['formData']['coverName'], { value: '' });
      formData['coverUuid'] = Object.assign(this.state['formData']['coverUuid'], { value: '' });
      this.setState({
        formData: formData,
        imgFile: null,
        imgEditable: false
      })
    }).catch(err => {
      Toast.error(err)
    })
  }

  //Cleaning time input box 
  clearStartTime = () => {
    let formData = this.state.formData;
    formData['effectiveStartDate'] = Object.assign(this.state['formData']['effectiveStartDate'], { value: null });
    this.setState({
      formData: formData
    });
  }
  clearEndTime = () => {
    let formData = this.state.formData;
    formData['effectiveEndDate'] = Object.assign(this.state['formData']['effectiveEndDate'], { value: null });
    this.setState({
      formData: formData
    });
  }

  handleOpenPicky = (value) => {
    this.setState({
      pickyStatus: true,
      pickyTime: '2019/03/24 14:59'
    });
  }
  handleClosePicky = () => {
    this.setState({
      pickyStatus: false,
    });
  }
  receiveHandle = (res) => {
    this.setState({
      pickyTime: res
    });
  }
  render() {
    const { classes } = this.props;
    const { dictWord, formData, currentFileData, categoryData, permissions } = this.state;
    let num = 1;
    return (
      <div className="mainDom" style={{ minWidth: '700px',height:'100%' }}>
       
        <div className={classes.appBarSpacer} />
        
        <Typography variant="h6" gutterBottom>
          {dictWord.content_base_information}
        </Typography>
        <div className={classes.space} />
        <Grid container className={classes.margin}>
          <Grid container className={classes.margin}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="title">
                {dictWord.notice_title}<span className={classes.required}>*</span>
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl error={formData.title.error} fullWidth>
                <InputBase
                  id="title"
                  value={formData.title.value}
                  onChange={this.handleChange('title')}
                  fullWidth
                  classes={{
                    root: classes.bootstrapRoot,
                    input: classes.bootstrapInput,
                  }}
                  error={formData.title.error}
                  disabled={this.state.disabledAll}
                // ref={(input) => this.input = input} 
                />
                {formData.title.error ? <FormHelperText id="title-error-text">{formData.title.errorMsg}</FormHelperText> : ''}
              </FormControl>
            </Grid>
          </Grid>
          <Grid container className={classes.margin}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="publishedDepartment">
                {dictWord.published_department}<span className={classes.required}>*</span>
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl error={formData.publisher.error} fullWidth>
                <InputBase
                  id="publisher"
                  value={formData.publisher.value}
                  onChange={this.handleChange('publisher')}
                  fullWidth
                  classes={{
                    root: classes.bootstrapRoot,
                    input: classes.bootstrapInput,
                  }}
                  error={formData.publisher.error}
                  disabled={this.state.disabledAll}
                />
                {formData.publisher.error ? <FormHelperText id="publisher-error-text">{formData.publisher.errorMsg}</FormHelperText> : ''}
              </FormControl>
            </Grid>
          </Grid>
          <Grid container className={classes.margin}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="publishedUserName">
                {dictWord.published_user_name}<span className={classes.required}>*</span>
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl error={formData.author.error} fullWidth>
                <InputBase
                  id="author"
                  value={formData.author.value}
                  onChange={this.handleChange('author')}
                  fullWidth
                  classes={{
                    root: classes.bootstrapRoot,
                    input: classes.bootstrapInput,
                  }}
                  error={formData.author.error}
                  disabled={this.state.disabledAll}
                />
                {formData.author.error ? <FormHelperText id="author-error-text">{formData.author.errorMsg}</FormHelperText> : ''}
              </FormControl>
            </Grid>
          </Grid>
          <Grid container className={classes.margin}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="contentDescription">
                {dictWord.content_description}
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputBase
                  id="introduction"
                  value={formData.introduction.value}
                  onChange={this.handleChange('introduction')}
                  onKeyUp={this.checkLength('introduction')}
                  fullWidth
                  rows="4"
                  multiline
                  classes={{
                    root: classes.bootstrapRoot,
                    input: classes.bootstrapInput,
                  }}
                  error={formData.introduction.error}
                  disabled={this.state.disabledAll}
                />
                {<FormHelperText error={formData.introduction.error} id="introduction-error-text">{formData.introduction.errorMsg}</FormHelperText>}
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.space} />
        <Typography variant="h6" gutterBottom>
          {dictWord.content_publish_information}
        </Typography>
        <div className={classes.space} />
        <Grid container className={classes.margin}>
          <Grid container className={classes.margin}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="categoryId">
                {dictWord.category}<span className={classes.required}>*</span>
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={10}>
              <Select
                value={formData.category.value}
                onChange={this.handleChange('category')}
                inputProps={{
                  name: 'category',
                }}
                input={<Input />}
                classes={{
                  root: classes.bootstrapRoot,
                  select: classes.bootstrapSelect,
                }}
                style={{ width: formData.category.width, position: 'relative' }}
                disabled={this.state.disabledAll}
              >
                {categoryData ? categoryData.map((item, j) => {
                  return <MenuItem key={j} value={item.categoryId}>
                    <Tooltip placement="bottom-start" disableFocusListener title={item.categoryName}>
                      {getUserInfo().roleId === 2 && item.vaildFlag === 0 ? <span style={{ marginLeft: 20 * (item.depth - 1), color: 'grey' }}>{item.categoryName}</span>
                        : <span style={{ marginLeft: 20 * (item.depth - 1) }}>{item.categoryName}</span>}
                    </Tooltip></MenuItem>
                }) : null}
              </Select>
              {formData.category.error ? <FormHelperText error={formData.category.error} id="category-error-text">{formData.category.errorMsg}</FormHelperText> : ''}
            </Grid>
          </Grid>
          <Grid container className={classes.margin}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="departmentSpecified">
                {dictWord.department_specified_release}
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl error={formData.DepartmentTags.error} fullWidth>
                <div className="tag-list">
                  {formData.DepartmentTags.value.map((column, j) => {
                    return <span key={j} disabled={this.state.disabledAll} className="tags">
                      {column.name}
                      <Close className="delBut" fontSize="inherit" color="action" onClick={this.handleDelTags(j)} />
                    </span>
                  })}
                </div>
                {formData.DepartmentTags.error ? <FormHelperText id="DepartmentTags-error-text">{formData.DepartmentTags.errorMsg}</FormHelperText> : ''}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button variant="contained" onClick={this.handleSearch} disabled={this.state.disabledAll} className={classes.margin} style={{ backgroundColor: this.state.disabledAll ? '' : '#1769aa', color: '#fff' }}>
                {dictWord.department_search}
              </Button>
            </Grid>
          </Grid>
          <Grid container className={classes.margin}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="userAppoint">
                {dictWord.user_appoint}
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <div className="tag-list">
                  {formData.UserTags.value.map((column, j) => {
                    return <span key={j} className="tags" disabled={this.state.disabledAll}>
                      {column.name}
                      <Close className="delBut" fontSize="inherit" color="action" onClick={this.handleDelUserTags(j)} />
                    </span>
                  })}
                </div>
                {formData.UserTags.error ? <FormHelperText id="UserTags-error-text" error={formData.UserTags.error}>{formData.UserTags.errorMsg}</FormHelperText> : ''}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button variant="contained" onClick={this.handleSearchUser} disabled={this.state.disabledAll} className={classes.margin} style={{ backgroundColor: this.state.disabledAll ? '' : '#1769aa', color: '#fff' }}>
                {dictWord.user_search}
              </Button>
            </Grid>
          </Grid>

          <Grid container className={classes.margin}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="userAppoint">
                {dictWord.printed_department_appoint}
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <div className="tag-list">
                  {formData.printingRelease.value.map((column, j) => {
                    return <span key={j} className="tags" disabled={this.state.disabledAll}>
                      {column.name}
                      <Close className="delBut" fontSize="inherit" color="action" onClick={this.handleDelPrintingTags(j)} />
                    </span>
                  })}
                </div>
                {formData.printingRelease.error ? <FormHelperText id="UserTags-error-text" error={formData.UserTags.printingRelease}>{formData.UserTags.errorMsg}</FormHelperText> : ''}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button variant="contained" onClick={this.handleSearchPrinting.bind(this)} disabled={this.state.disabledAll} className={classes.margin} style={{ backgroundColor: this.state.disabledAll ? '' : '#1769aa', color: '#fff' }}>
                {dictWord.department_search}
              </Button>
            </Grid>
          </Grid>

          <Grid container className={classes.margin}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="userAppoint">
                {dictWord.printed_user_appoint}
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <div className="tag-list">
                  {formData.printingUser.value.map((column, j) => {
                    return <span key={j} className="tags" disabled={this.state.disabledAll}>
                      {column.name}
                      <Close className="delBut" fontSize="inherit" color="action" onClick={this.handleDelPrintUserTags(j)} />
                    </span>
                  })}
                </div>
                {formData.UserTags.error ? <FormHelperText id="UserTags-error-text" error={formData.UserTags.error}>{formData.UserTags.errorMsg}</FormHelperText> : ''}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button variant="contained" onClick={this.handleSearchPrintUser.bind(this)} disabled={this.state.disabledAll} className={classes.margin} style={{ backgroundColor: this.state.disabledAll ? '' : '#1769aa', color: '#fff' }}>
                {dictWord.user_search}
              </Button>
            </Grid>
          </Grid>

          <Grid container className={classes.margin}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="readExpiresPeriod">
                {dictWord.read_expires_period}
              </InputLabel>
            </Grid>

            <Grid item xs={12} md={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                <div className="picker">
                  <DateTimePicker ampm={false} format="yyyy/MM/dd HH:mm" value={formData.effectiveStartDate.value} disabled={this.state.disabledAll} onChange={this.handleChange('effectiveStartDate')} />
                  <Clear
                    color="disabled"
                    style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                    onClick={this.clearStartTime}
                  />
                </div>

              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={2} md={1} style={{ maxWidth: '44px', marginLeft: '0px', marginRight: '0px', display: 'inlineBlock', lineHeight: '34px', textAlign: 'center' }}> <span>~</span> </Grid>
            <Grid item xs={12} md={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                <div className="picker">
                  <DateTimePicker ampm={false} format="yyyy/MM/dd HH:mm" value={formData.effectiveEndDate.value} disabled={this.state.disabledAll} onChange={this.handleChange('effectiveEndDate')} />
                  <Clear
                    color="disabled"
                    style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                    onClick={this.clearEndTime}
                  />
                </div>
              </MuiPickersUtilsProvider>
              {formData.effectiveEndDate.error ? <FormHelperText id="effectiveEndDate-error-text" error={formData.effectiveEndDate.error}>{formData.effectiveEndDate.errorMsg}</FormHelperText> : ''}
            </Grid>
          </Grid>
          <Grid container className={classes.margin}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="isOpen">
                {dictWord.book_open_state}
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={4}>
              <RadioGroup
                aria-label="isOpen"
                name="isOpen"
                value={formData.isOpen.value}
                onChange={this.handleChange('isOpen')}
                row
              >
                <FormControlLabel
                  value="0"
                  control={<Radio className={classes.Radio} color="primary" />}
                  label={dictWord.public}
                  labelPlacement="end"
                  disabled={this.state.disabledAll}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio className={classes.Radio} color="primary" />}
                  label={dictWord.non_public}
                  labelPlacement="end"
                  disabled={this.state.disabledAll}
                />
              </RadioGroup>
            </Grid>
          </Grid>

          {permissions.includes(27) || permissions.includes(28) ?
            <Grid container className={classes.margin}>
              <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                <InputLabel shrink htmlFor="contentUpdateNotification">
                  {dictWord.content_update_notification}
                </InputLabel>
              </Grid>
              <Grid item xs={12} md={4}>
                {permissions.includes(28) ?
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.Checkbox}
                        checked={formData.pushDelivery.value}
                        onChange={this.handleChange('pushDelivery')}
                        disabled={formData.contentLink.value === '1' || formData.isOpen.value === '1' ? true : false}
                      />
                    }
                    label={this.state.dictWord.push_notice}
                  /> : null}
                {permissions.includes(27) ?
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.Checkbox}
                        checked={formData.mailDelivery.value}
                        onChange={this.handleChange('mailDelivery')}
                        disabled={formData.contentLink.value === '1' || formData.isOpen.value === '1' ? true : false}
                      />
                    }
                    label={this.state.dictWord.mail_delivery}
                  />
                  : null}
              </Grid>
            </Grid> : null}
          {formData.mailDelivery.value ?
            <Grid container className={classes.margin} >
              <Grid item xs={12} md={2} >
                <InputLabel shrink htmlFor="changeSummary">
                  {dictWord.change_summary}
                </InputLabel>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <InputBase
                    id="changeSummary"
                    value={formData.changeSummary.value}
                    onChange={this.handleChange('changeSummary')}
                    onKeyUp={this.checkLength('changeSummary')}
                    fullWidth
                    rows="4"
                    multiline
                    classes={{
                      root: classes.bootstrapRoot,
                      input: classes.bootstrapInput,
                    }}
                    error={formData.changeSummary.error}
                    disabled={this.state.disabledAll}
                  />
                  {<FormHelperText error={formData.changeSummary.error} id="changeSummary-error-text">{formData.changeSummary.errorMsg}</FormHelperText>}
                </FormControl>
              </Grid>
            </Grid> : null}
        </Grid>
        <div className={classes.space} />
        <Typography variant="h6" gutterBottom>
          {dictWord.content_upload_detail}
        </Typography>
        <div className={classes.space} />
        <Grid container className={classes.margin}>
          <Grid container style={{ margin: '8px 12px' }}>
            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
              <InputLabel shrink htmlFor="content" style={{ marginLeft: '-5px' }}>
                {dictWord.content_link}
              </InputLabel>
            </Grid>
            <Grid item xs={12} md={4}>
              <RadioGroup
                aria-label="content"
                name="content"
                value={formData.contentLink.value}
                onChange={this.handleChange('contentLink')}
                row

              >
                <FormControlLabel
                  value="0"
                  control={<Radio className={classes.Radio} color="primary" />}
                  label={dictWord.content}
                  labelPlacement="end"
                  disabled={this.props.match.params.id !== undefined ? true : false}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio className={classes.Radio} color="primary" />}
                  label={dictWord.link}
                  labelPlacement="end"
                  disabled={this.props.match.params.id !== undefined ? true : false}
                />
              </RadioGroup>
            </Grid>
          </Grid>

          {
            this.state.formData.contentLink.value === '0' ?
              <section style={{ width: '100%' }}>
                <Grid container className={classes.margin}>
                  <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                    <InputLabel shrink htmlFor="downloadWay">
                      {dictWord.release_method}
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <RadioGroup
                      aria-label="downloadWay"
                      name="downloadWay"
                      value={formData.downloadWay.value}
                      onChange={this.handleChange('downloadWay')}
                      row
                    >
                      <FormControlLabel
                        value="0"
                        control={<Radio className={classes.Radio} color="primary" />}
                        label={dictWord.mixture}
                        labelPlacement="end"
                        disabled={this.state.disabledAll}
                      />
                      <FormControlLabel
                        value="1"
                        control={<Radio className={classes.Radio} color="primary" />}
                        label={dictWord.download}
                        labelPlacement="end"
                        disabled={this.state.disabledAll}
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio className={classes.Radio} color="primary" />}
                        label={dictWord.streaming}
                        labelPlacement="end"
                        disabled={this.state.disabledAll}
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                  <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                    <InputLabel shrink htmlFor="uploadFile">
                      {dictWord.upload_file}<span className={classes.required}>*</span>
                    </InputLabel>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <div style={{ border: '1px solid #ccc', minWidth: '442px', padding: '5px' }}>
                      <Grid item xs={12} md={10}>
                        <input
                          accept=".pdf,.epub,.mp4"
                          className={classes.fileInput}
                          id="button-file"
                          type="file"
                          onChange={this.onPdfDrop.bind(this)}
                          disabled={this.state.disabledAll ? true : formData.fileUuid.value.length < 1 ? false : true}
                        />
                        <label htmlFor="button-file">
                          <InputBase readOnly classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect }} />
                          <Button variant="contained" component="span" color={this.state.disabledAll ? 'default' : formData.fileUuid.value.length < 1 ? "primary" : 'default'} className={classes.cusButton} onClick={this.fileButton.bind(this, 'button-file')}>
                            {dictWord.file_select}
                          </Button>
                        </label>
                      </Grid>
                      {formData.fileName.value.length > 0 ? <Grid container className={classes.margin}>
                        <Grid item xs={12} md={6}>
                          <p title={formData.coverName.value} style={{ maxWidth: '209px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                            {formData.fileName.value}
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Button variant="contained" color="primary" onClick={this.handlePdfUpload} className={classes.margin} disabled={this.state.disabledAll ? true : formData.fileUuid.value.length < 1 && this.state.pdfFile && this.state.pdfUpLoading === false ? false : true}>
                            {dictWord.upload}
                            <Fade
                              in={this.state.pdfUpLoading}
                              style={{
                                transitionDelay: this.state.pdfUpLoading ? '800ms' : '0ms',
                              }}
                              unmountOnExit
                            >
                              <CircularProgress size={24} className={classes.buttonProgress} />
                            </Fade>
                          </Button>
                          {formData.fileUuid.value.length > 0 ?
                            <Button variant="contained" color="primary" disabled={this.state.disabledAll} onClick={this.handlePdfClear} className={classes.margin}>
                              {dictWord.clear}
                            </Button> : null}
                        </Grid>
                      </Grid> : null}
                      {this.state.pdfEditable ? <Grid container className={classes.margin}>
                        <Grid item xs={12} md={4} className={classes.bootstrapFormLabel} />
                        <Grid item xs={12} md={8}>
                          <Button variant="contained" onClick={this.handleEditFile} style={{ backgroundColor: this.state.disabledAll ? '' : '#1769aa', color: '#fff' }} disabled={this.state.disabledAll ? true : this.state.pdfEditImgLoading}>
                            {dictWord.page_edit}
                            <Fade
                              in={this.state.pdfEditImgLoading}
                              style={{
                                transitionDelay: this.state.pdfEditImgLoading ? '800ms' : '0ms',
                              }}
                              unmountOnExit
                            >
                              <CircularProgress size={24} className={classes.buttonProgress} />
                            </Fade>
                          </Button>
                        </Grid>
                      </Grid> : null}
                      {formData.fileUuid.error ? <FormHelperText id="fileUuid-error-text" error={formData.fileUuid.error}>{formData.fileUuid.errorMsg}</FormHelperText> : ''}
                      <div className={classes.fileTips}>
                        {dictWord.upload_only_files_type}<br />
                        {dictWord.max_file_size.replace('%s', this.state.file_size)}
                      </div>
                    </div>
                    
                  </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                  <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                    <InputLabel shrink htmlFor="coverImage">
                      {dictWord.cover_image}
                    </InputLabel>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <div style={{ border: '1px solid #ccc', minWidth: '442px', padding: '5px' }}>
                      <Grid item xs={12} md={10}>
                        <div>
                          <FormControlLabel
                            control={
                              <Checkbox
                                className={classes.Checkbox}
                                checked={formData.firstPage.value}
                                onChange={this.handleChange('firstPage')}
                                disabled={this.state.disabledAll}
                              />
                            }
                            label={dictWord.first_page_uses_cover_image}
                          />
                        </div>
                        <div>
                          <input
                            accept=".gif,.png,.jpg,.jpeg"
                            className={classes.fileInput}
                            id="coverButton-file"
                            type="file"
                            onChange={this.onImgDrop.bind(this)}
                            disabled={this.state.disabledAll ? true : formData.firstPage.value === true || formData.coverName.value.length > 0 ? true : false}
                          />
                          <label htmlFor="coverButton-file">
                            <InputBase readOnly classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect }} />
                            <Button variant="contained" component="span" color={this.state.disabledAll ? 'default' : formData.firstPage.value === true || formData.coverName.value.length > 0 ? 'default' : 'primary'} className={classes.cusButton} onClick={this.fileButton.bind(this, 'coverButton-file')}>
                              {dictWord.file_select}
                            </Button>
                          </label>
                        </div>
                      </Grid>
                      {formData.coverName.value.length > 0 ? <Grid container className={classes.margin}>
                        <Grid item xs={12} md={6}>
                          <p title={formData.coverName.value} style={{ maxWidth: '209px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                            {formData.coverName.value}
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Button variant="contained" color="primary" onClick={this.handleImgUpload} className={classes.margin} disabled={this.state.disabledAll ? true : this.state.imgEditable === false && this.state.imgUpLoading === false ? false : true}>
                            {dictWord.upload}
                            <Fade
                              in={this.state.imgUpLoading}
                              style={{
                                transitionDelay: this.state.imgUpLoading ? '800ms' : '0ms',
                              }}
                              unmountOnExit
                            >
                              <CircularProgress size={24} className={classes.buttonProgress} />
                            </Fade>
                          </Button>
                          {formData.coverUuid.value.length > 0 ?
                            <Button variant="contained" color="primary" disabled={this.state.disabledAll} onClick={this.handleImgClear} className={classes.margin}>
                              {dictWord.clear}
                            </Button> : null}
                        </Grid>
                      </Grid> : null}
                      {formData.coverName.error || formData.coverUuid.error ?
                        <FormHelperText id="coverUuid-error-text" error={formData.coverName.error || formData.coverUuid.error}>{formData.coverName.errorMsg || formData.coverUuid.errorMsg}</FormHelperText> : ''}
                    <div className={classes.fileTips}>{dictWord.upload_only_image_files}</div>
                    </div>
                  </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                  <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                    <InputLabel shrink htmlFor="flip">
                      {dictWord.page_methods}
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <RadioGroup
                      aria-label="flip"
                      name="flip"
                      value={formData.flip.value}
                      onChange={this.handleChange('flip')}
                      row
                    >
                      <FormControlLabel
                        value="0"
                        control={<Radio className={classes.Radio} color="primary" />}
                        label={dictWord.left_methods}
                        labelPlacement="end"
                        disabled={this.state.disabledAll ? this.state.disabledAll : this.state.disabledMp4}
                      />
                      <FormControlLabel
                        value="1"
                        control={<Radio className={classes.Radio} color="primary" />}
                        label={dictWord.right_methods}
                        labelPlacement="end"
                        disabled={this.state.disabledAll ? this.state.disabledAll : this.state.disabledMp4}
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                  <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                    <InputLabel shrink htmlFor="isHorizontal">
                      {dictWord.side_special}
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <RadioGroup
                      aria-label="isHorizontal"
                      name="isHorizontal"
                      value={formData.isHorizontal.value}
                      onChange={this.handleChange('isHorizontal')}
                      row
                    >
                      <FormControlLabel
                        value="0"
                        control={<Radio className={classes.Radio} color="primary" />}
                        label={dictWord.invalid}
                        labelPlacement="end"
                        disabled={this.state.disabledAll ? this.state.disabledAll : this.state.disabledMp4}
                      />
                      <FormControlLabel
                        value="1"
                        control={<Radio className={classes.Radio} color="primary" />}
                        label={dictWord.valid}
                        labelPlacement="end"
                        disabled={this.state.disabledAll ? this.state.disabledAll : this.state.disabledMp4}
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                  <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                    <InputLabel shrink htmlFor="bootstrap-input">
                      {dictWord.side_special_page_count}
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <RadioGroup
                      aria-label="horizontalPageCount"
                      name="horizontalPageCount"
                      value={formData.isHorizontal.value === '1' ? this.state.formData.horizontalPageCount.value : ""}
                      onChange={this.handleChange('horizontalPageCount')}
                      row
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio color="primary" />}
                        label={dictWord['1screen_1page_show']}
                        labelPlacement="end"
                        disabled={formData.isHorizontal.value === '1' ? false : true}
                      />
                      <FormControlLabel
                        value="0"
                        control={<Radio className={classes.Radio} color="primary" />}
                        label={dictWord['1screen_2page_show']}
                        labelPlacement="end"
                        disabled={formData.isHorizontal.value === '1' ? false : true}
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
              </section> :
              <section style={{ width: '100%' }}>
                <Grid container className={classes.margin}>
                  <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                    <InputLabel shrink htmlFor="links">
                      {dictWord.link}<span className={classes.required}>*</span>
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormControl error={formData.links.error} fullWidth>
                      <InputBase
                        id="links"
                        value={formData.links.value}
                        onChange={this.handleChange('links')}
                        fullWidth
                        classes={{
                          root: classes.bootstrapRoot,
                          input: classes.bootstrapInput,
                        }}
                        error={formData.links.error}
                        disabled={this.state.disabledAll}
                      />
                      {formData.links.error ? <FormHelperText id="links-error-text">{formData.links.errorMsg}</FormHelperText> : ''}
                    </FormControl>
                  </Grid>

                </Grid>
                <Grid container className={classes.margin}>
                  <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                    <InputLabel shrink htmlFor="coverImage">
                      {dictWord.cover_image}
                    </InputLabel>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <div style={{ border: '1px solid #ccc', minWidth: '442px', padding: '5px' }}>
                      <Grid item xs={12} md={10}>
                        <div>
                          <FormControlLabel
                            control={
                              <Checkbox
                                className={classes.Checkbox}
                                checked={formData.firstPage.value}
                                onChange={this.handleChange('firstPage')}
                                disabled={this.state.disabledAll ? this.state.disabledAll : this.state.formData.contentLink.value.toString() === '1' ? true : false}
                              />
                            }
                            label={dictWord.first_page_uses_cover_image}
                          />
                        </div>
                        <div>
                          <input
                            accept="image/*"
                            className={classes.fileInput}
                            id="coverButton-file"
                            type="file"
                            onChange={this.onImgDrop.bind(this)}
                            disabled={this.state.disabledAll ? true : formData.firstPage.value === true || formData.coverName.value.length > 0 ? true : false}
                          />
                          <label htmlFor="coverButton-file">
                            <InputBase readOnly classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect }} />
                            <Button variant="contained" component="span" color={this.state.disabledAll ? 'default' : formData.firstPage.value === true || formData.coverName.value.length > 0 ? 'default' : 'primary'} className={classes.cusButton} onClick={this.fileButton.bind(this, 'coverButton-file')}>
                              {dictWord.file_select}
                            </Button>
                          </label>
                        </div>
                      </Grid>
                      {formData.coverName.value.length > 0 ? <Grid container className={classes.margin}>
                        <Grid item xs={12} md={6}>
                          <p title={formData.coverName.value} style={{ maxWidth: '209px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                            {formData.coverName.value}
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Button variant="contained" color="primary" onClick={this.handleImgUpload} className={classes.margin} disabled={this.state.disabledAll ? true : this.state.imgEditable === false && this.state.imgUpLoading === false ? false : true}>
                            {dictWord.upload}
                            <Fade
                              in={this.state.imgUpLoading}
                              style={{
                                transitionDelay: this.state.imgUpLoading ? '800ms' : '0ms',
                              }}
                              unmountOnExit
                            >
                              <CircularProgress size={24} className={classes.buttonProgress} />
                            </Fade>
                          </Button>
                          {formData.coverUuid.value.length > 0 ?
                            <Button variant="contained" color="primary" disabled={this.state.disabledAll} onClick={this.handleImgClear} className={classes.margin}>
                              {dictWord.clear}
                            </Button> : null}
                        </Grid>
                      </Grid> : null}
                      {formData.coverName.error || formData.coverUuid.error ?
                        <FormHelperText id="coverUuid-error-text" error={formData.coverName.error || formData.coverUuid.error}>{formData.coverName.errorMsg || formData.coverUuid.errorMsg}</FormHelperText> : ''}
                    </div>
                  </Grid>
                </Grid>
              </section>
          }
        </Grid>
        {/* fwf temp tag */}
        <Grid container className={classes.margin}>
          {this.state.disabledAll ? null : <Typography variant="h5" gutterBottom className={classes.buttonlogin}>
            <Button variant="contained" color="primary" onClick={this.handleSubmit}>
              {dictWord.registration}
            </Button>
          </Typography>}
          <Typography variant="h5" gutterBottom className={this.state.disabledAll ? classes.buttonlogin : null}>
            <Link to="/admin/content/content" className={classes.link}>
              <Button variant="contained" color="primary" className={classes.buttoncancel}>
                {dictWord.cancel}
              </Button>
            </Link>
          </Typography>
        </Grid>
        <Dialog
          open={this.state.dialogOpenSearch}
          option={{
            close: {
              text: this.state.dictWord['close'],
            },
            maxWidth:false
          }}
          titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['department_search']}</DialogTitle>}
          content={
            <div>
              <div className={classes.margin}>
                <div className={classes.bootstrapFormLabel}>
                  <InputLabel shrink htmlFor="name">
                    {dictWord.department_designation}
                  </InputLabel>
                </div>
                <div>
                  <InputBase
                    style={{minWidth:'265px'}}
                    id="name"
                    value={this.state.name}
                    fullWidth
                    inputProps={{
                      autocomplete:"off"
                    }}
                    onChange={this.inputHandleSearch.bind(this, 'department')}
                    onFocus={this.inputHandleSearch.bind(this, 'department')}
                    classes={{
                      root: classes.bootstrapRoot,
                      input: classes.bootstrapInput,
                    }}
                  />
                  {this.state.show ? <Paper className={classes.paper}>
                    <MenuList>
                      {this.state.department.map((column, j) => {
                        return <MenuItem key={j} style={{minWidth:'230px'}} onClick={this.handleSearchValue(column.name, column.id)}>{column.name}</MenuItem>
                      })}
                    </MenuList>
                  </Paper> : null}
                </div>
              </div>
            </div>
          }
          handleClose={this.dialogHandleOff}
        />
        <Dialog
          open={this.state.dialogOpenSearchUser}
          option={{
            close: {
              text: this.state.dictWord['close'],
            },
            maxWidth: false,
          }}
          titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['user_search']}</DialogTitle>}
          content={
            <div>
              <div className={classes.margin}>
                <div className={classes.bootstrapFormLabel}>
                  <InputLabel shrink htmlFor="name">
                    {dictWord.user_name}
                  </InputLabel>
                </div>
                <div>
                  <InputBase
                    style={{ minWidth: '265px' }}
                    id="name"
                    value={this.state.name}
                    fullWidth
                    inputProps={{
                      autoComplete: "off"
                    }}
                    onChange={this.inputHandleSearchUser.bind(this, 'user')}
                    onFocus={this.inputHandleSearchUser.bind(this, 'user')}
                    classes={{
                      root: classes.bootstrapRoot,
                      input: classes.bootstrapInput,
                    }}
                  />
                  {this.state.show ? <Paper className={classes.paper}>
                    <MenuList>
                      {this.state.user.map((column, j) => {
                        return <MenuItem key={j} style={{ minWidth: '230px' }} onClick={this.handleSearchUserValue(column.name, column.id)}>{column.name}</MenuItem>
                      })}
                    </MenuList>
                  </Paper> : null}
                </div>
              </div>
            </div>
          }
          handleClose={this.dialogHandleFalse}
        />

        <Dialog
          open={this.state.dialogOpenSearchPrinting}
          option={{
            close: {
              text: this.state.dictWord['close'],
            },
            maxWidth:false
          }}
          titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['department_search']}</DialogTitle>}
          content={
            <div>
              <div className={classes.margin}>
                <div className={classes.bootstrapFormLabel}>
                  <InputLabel shrink htmlFor="name">
                    {dictWord.department_designation}
                  </InputLabel>
                </div>
                <div>
                  <InputBase
                    style={{minWidth:'265px'}}
                    id="name"
                    value={this.state.name}
                    fullWidth
                    inputProps={{
                      autoComplete:"off"
                    }}
                    onChange={this.inputHandleSearch.bind(this, 'Printing')}
                    onFocus={this.inputHandleSearch.bind(this, 'Printing')}
                    classes={{
                      root: classes.bootstrapRoot,
                      input: classes.bootstrapInput,
                    }}
                  />
                  {this.state.show ? <Paper className={classes.paper}>
                    <MenuList>
                      {this.state.printingRelease.map((column, j) => {
                        return <MenuItem key={j} style={{minWidth:'230px'}} onClick={this.handleSearchPrint(column.name, column.id)}>{column.name}</MenuItem>
                      })}
                    </MenuList>
                  </Paper> : null}
                </div>
              </div>
            </div>
          }
          handleClose={this.dialogHandleFalse}
        />

        <Dialog
          open={this.state.dialogOpenSearchPrintUser}
          option={{
            close: {
              text: this.state.dictWord['close'],
            },
            maxWidth:false
          }}
          titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['user_search']}</DialogTitle>}
          content={
            <div>
              <div className={classes.margin}>
                <div className={classes.bootstrapFormLabel}>
                  <InputLabel shrink htmlFor="name">
                    {dictWord.user_name}
                  </InputLabel>
                </div>
                <div>
                  <InputBase
                    style={{minWidth:'265px'}}
                    id="name"
                    value={this.state.name}
                    fullWidth
                    inputProps={{
                      autoComplete:"off"
                    }}
                    onChange={this.inputHandleSearchUser.bind(this, 'PrintUser')}
                    onFocus={this.inputHandleSearchUser.bind(this, 'PrintUser')}
                    classes={{
                      root: classes.bootstrapRoot,
                      input: classes.bootstrapInput,
                    }}
                  />
                  {this.state.show ? <Paper className={classes.paper}>
                    <MenuList>
                      {this.state.printingUser.map((column, j) => {
                        return <MenuItem key={j} style={{minWidth:'230px'}} onClick={this.handleSearchPrintingUser(column.name, column.id)}>{column.name}</MenuItem>
                      })}
                    </MenuList>
                  </Paper> : null}
                </div>
              </div>
            </div>
          }
          handleClose={this.dialogHandleFalse}
        />

        <Dialog
          open={this.state.dialogEdit}
          option={{
            maxWidth: 'lg',
            close: {
              text: this.state.dictWord['close'],
            },
          }}
          content={
            <div>
              <Grid item xs={12} md={12}>
                <BottomNavigation
                  showLabels
                  style={{
                    justifyContent: 'left',
                    height: '100%',
                    display: 'block',
                    marginBottom: '5px'
                  }}
                >
                  <BottomNavigationAction style={{ border: '1px solid #ccc', borderRight: 'none' }} label={dictWord.original_return} icon={<ReturnIcon style={{ color: this.state.previousDisabled ? '#CED4DA' : '#0565F6' }} />} disabled={this.state.previousDisabled} onClick={this.previous} />
                  <BottomNavigationAction style={{ border: '1px solid #ccc', borderLeft: 'none' }} label={dictWord.start_again} icon={<AgainIcon style={{ color: this.state.nextDisabled ? '#CED4DA' : '#0565F6' }} />} disabled={this.state.nextDisabled} onClick={this.next} />
                  <BottomNavigationAction style={{ border: '1px solid #ccc', borderLeft: 'none', borderRight: 'none' }} label={this.state.isSelectBox === true ? dictWord.cancel : dictWord.select_record} icon={this.state.isSelectBox === true ? <Cancel style={{ color: '#DE561A' }} /> : <Done style={{ color: '#DE561A' }} />} onClick={this.state.isSelectBox === true ? this.multipleSelectionCancel : this.multipleSelection} />
                  <BottomNavigationAction style={{ border: '1px solid #ccc', borderRight: 'none' }} label={dictWord.insert_record} icon={<NoteAdd style={{ color: this.state.addDisabled ? '#CED4DA' : '#1A8e9a' }} />} onClick={this.fileButton.bind(this, 'add-file')} />
                  <BottomNavigationAction style={{ border: '1px solid #ccc', borderLeft: 'none', borderRight: 'none' }} label={dictWord.delete_record} icon={<FileDel style={{ color: this.state.delDisabled ? '#CED4DA' : '#DE2F32' }} />} disabled={this.state.delDisabled} onClick={this.delFile} />
                  <BottomNavigationAction style={{ border: '1px solid #ccc', borderRight: 'none' }} label={dictWord.before} icon={<ArrowBack style={{ color: this.state.upDisabled ? '#CED4DA' : '#E9511A' }} />} disabled={this.state.upDisabled} onClick={this.fileUp} />
                  <BottomNavigationAction style={{ border: '1px solid #ccc', borderLeft: 'none', }} label={dictWord.after} icon={<ArrowForward style={{ color: this.state.downDisabled ? '#CED4DA' : '#E9511A' }} />} disabled={this.state.downDisabled} onClick={this.fileDown} />
                </BottomNavigation>
                <input
                  accept=".pdf"
                  className={classes.fileInput}
                  id="add-file"
                  type="file"
                  onChange={this.addFile.bind(this)}
                  disabled={this.state.addDisabled}
                />
              </Grid>
              <GridList className={classes.gridList} >
                {currentFileData.map((file, i) => {
                  file['pageNumber'] = num;
                  if (file && file.optFlg !== 1) {
                    num++;
                  }
                  // if (file.img) {
                  return file.img ? <GridListTile key={i} style={{ width: '10%', minWidth: '120px', backgroundColor: '#fff', display: file && file.optFlg === 1 ? 'none' : null }} >
                    <div id={'imgBox' + i} style={{ border: "1px solid #ccc", padding: '1px', height: '80%' }} onClick={this.handleEnlargeImg.bind(this, i)}>
                      {file.img ? <img src={file.img} alt="" key="img" id={'img' + i} onLoad={this.imgLoad(file.img, i, file.rotation)} /> : null}
                    </div>
                    <Fade
                      key="fade"
                      in={this.state.LoadEnlargeImg[i]}
                      style={{
                        transitionDelay: '800ms',
                      }}
                      unmountOnExit
                    >
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    </Fade>
                    <GridListTileBar
                      onClick={this.handleFileSelect(i)}
                      style={{ height: '20%' }}
                      titlePosition="bottom"
                      title={file['pageNumber']}
                      actionPosition="right"
                      actionIcon={
                        this.state.isSelectBox === true ?
                          this.state.multipleFileSel.includes(i) ? <CheckBox color="error" /> :
                            <CheckBoxOutlineBlank color="disabled" /> : this.state.fileSel === i ?
                            <RadioButtonChecked color="error" /> :
                            <RadioButtonUnchecked color="disabled" />
                      }
                    />
                  </GridListTile> : null;
                  // }

                })}
                <div style={{ width: '100%', height: 'auto', textAlign: 'center' }}>
                  {this.state.loadMoreImgShow ? <Button className={classes.button} onClick={this.loadMoreImg.bind(this)}>
                    {this.state.loadingMore ?
                      <Fade
                        in={this.state.loadingMore}
                        style={{
                          transitionDelay: '800ms',
                        }}
                        unmountOnExit
                      >
                        <CircularProgress size={24} className={classes.buttonProgress} />
                      </Fade>
                      : dictWord.load_more}
                  </Button> : null}
                </div>

              </GridList>

            </div>
          }
          handleClose={this.fileEditDialogHandleClose}
        />
        <Dialog
          open={this.state.dialogOpen}
          option={{
            ok: {
              text: this.state.dictWord['yes'],
            },
            close: {
              text: this.state.dictWord['cancel'],
            },
          }}
          titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
          content={
            <p>{this.state.dictWord['msg_warning_content_information']}</p>
          }
          okLoading={this.state.okLoading}
          handleOk={this.dialogHandleOK}
          handleClose={this.dialogHandleClose}
        />

        <Dialog
          open={this.state.enlargeImgFlag}
          option={{
            topClose: true
          }}
          titleDoc={<DialogTitle disableTypography id="" className={classes.title} style={{ width: '97%' }}>{''}</DialogTitle>}
          content={
            <div style={{ overflowY: 'initial' }}>
              <BottomNavigation
                showLabels
                style={{
                  justifyContent: 'left',
                  height: '100%',
                  display: 'block',
                  marginBottom: '5px'
                }}
              >
                <BottomNavigationAction style={{ border: '1px solid #ccc', borderRight: 'none' }} label={dictWord.left_90degrees} icon={<Undo style={{ color: '#CB6BA2' }} />} onClick={this.leftRotate} />
                <BottomNavigationAction style={{ border: '1px solid #ccc', borderLeft: 'none', borderRight: 'none' }} label={dictWord.right_90degrees} icon={<Redo style={{ color: '#CB6BA2' }} />} onClick={this.rightRotate} />
                <BottomNavigationAction style={{ border: '1px solid #ccc', borderLeft: 'none', borderRight: 'none' }} label={dictWord.save_record} icon={<ContentSave style={{ color: '#CB6BA2' }} />} onClick={this.saveSingleImg} />
                <BottomNavigationAction style={{ border: '1px solid #ccc', borderLeft: 'none' }} label={dictWord.download} icon={<Download style={{ color: '#CB6BA2' }} />} onClick={this.downloadSinglePDF.bind(this)} />
              </BottomNavigation>
              <img src={this.state.singleImgSrc} alt="" id="imgEnlarge" onLoad={this.imgLoad(this.state.singleImgData.img, 'Enlarge', this.state.singleImgData.rotation)} style={{ width: '400px', display: 'block' }} />
            </div>
          }
          okLoading={this.state.okLoading}
          handleOk={this.dialogHandleOK}
          handleClose={this.closeEnlargeImg.bind(this)}
        />
        {this.state.pageLoading === true ?
          <div className={classes.mask}>
            <CircularProgress size={60} style={{ marginLeft: '15%' }} />
          </div>
          : null}
      </div>
    )
  }
}

ContentEdit.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContentEdit);